// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:04.115Z
// Property: Iron Ridge and Stonegate Apartments (ID: 6767906449166323)
// Collections: 33 amenities, 41 floorplans (live), 34 photos, 84 POIs, 3 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166323",
  "property_external_id": "30953",
  "property_zillow_url": "https://www.zillow.com/apartments/elkton-md/iron-ridge-and-stonegate-apartments/5XtNcp/",
  "property_apartments_url": "https://www.apartments.com/iron-ridge-and-stonegate-apartments-elkton-md/27hl8l8/",
  "property_google_business_url": "https://www.google.com/maps/place/Iron+Ridge+and+Stonegate+Apartments/data=!4m2!3m1!1s0x0:0x2ca892f62d8c9e39?sa=X&ved=2ahUKEwjI1PnLrLiSAxXsczABHSwFIG4Q_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54596677700",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "iron-ridge-and-stonegate-apartments",
  "property_name": "Iron Ridge and Stonegate Apartments",
  "property_website_url": "https://www.ironridgestonegateapartments.com/",
  "property_domain": "https://www.ironridgestonegateapartments.com/",
  "property_address": "4301 Stone Gate Blvd",
  "property_full_address": "4301 Stone Gate Blvd, Elkton, MD 21921",
  "property_address_1": "4301 Stone Gate Blvd",
  "property_address_2": null,
  "property_address_city": "Elkton",
  "property_address_state": "MD",
  "property_address_zip_full": "21921-4045",
  "property_address_zip": "21921",
  "property_address_country": "US",
  "property_address_county": "Cecil County",
  "property_neighborhood_address": "Cecil County",
  "property_address_latitude": "39.6528682",
  "property_address_longitude": "-75.7893632",
  "property_email": "ironridgestonegate@aionmanagement.com",
  "property_phone": "(410) 398-4800",
  "property_call_tracking_phone": "855-429-2821",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD, where comfort meets convenience. With spacious one, two, and three-bedroom layouts, top-notch amenities like a swimming pool, fitness center, and dog park redefine your living experience. Claim your oasis today—check our availability or schedule a tour!",
  "property_long_description": "Welcome to Iron Ridge and Stonegate Apartments in the heart of Elkton, MD – your ideal haven for modern living! Choose from a variety of thoughtfully designed floor plans, including one-, two-, and three-bedroom apartments, perfect for singles, couples, and families alike. Our homes boast stylish granite and stainless appliances, cozy wall-to-wall carpeting, and luxurious private balconies or patios to unwind on.\n\nAt Iron Ridge and Stonegate, we prioritize your lifestyle. Enjoy a wealth of amenities tailored to enhance your experience, including a state-of-the-art fitness center, a refreshing swimming pool, and a vibrant resident lounge. Whether you’re engaging in friendly competition on our basketball or tennis courts, hosting a barbecue at our grilling stations, or watching the sunset with a picnic near the pond, there's something for everyone.\n\nStay connected with our online resident portal and benefit from on-site management and 24-hour emergency maintenance for your peace of mind. Plus, our flexible rent payment options and short-term leases make it easy to find a home that fits your needs. For pet lovers, our community is pet-friendly, complete with a dedicated dog park!\n\nExperience engaging resident activities that foster community connections. With convenient access to on-site parking, garages available, and a business center for remote work needs, Iron Ridge and Stonegate Apartments combines comfort with practicality.\n\nFind your new home today — browse our availability or schedule a tour to visit our vibrant community! Your dream apartment awaits at Iron Ridge and Stonegate!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-7035-7547-be07-39b103b897e1.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and tables next to a building",
    "public_id": "019fcdfe-7035-7547-be07-39b103b897e1",
    "storage_key": "property/6767906449166323/019fcdfe-7035-7547-be07-39b103b897e1.webp",
    "width": 1280,
    "height": 854
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "260",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.43589743589743",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "All pets must be housebroken; no breeding allowed. Certain breeds are prohibited, including German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf‑dog hybrids, Pit Bulls, Presa Canarios, and mixes ≥50%.",
  "property_pet_policy_description": "We welcome dogs, cats, and service animals. All must be housebroken; no breeding allowed. Certain breeds (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf‑dog hybrids, Pit Bulls, Presa Canarios, and mixes ≥50%) are prohibited. A one‑time non‑refundable pet fee of $300 per pet is due at move‑in. Monthly pet rent is $50 for the first pet and $25 for the second. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://ironridge.loftliving.com/login",
  "property_apply_now_url": "https://www.ironridgestonegateapartments.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0268-baa7-7712-9065-14dd974ca258.webp",
  "property_primary_logo_media": {
    "alt_text": "Iron Ridge & Stonegate Apartments logo",
    "public_id": "019d0268-baa7-7712-9065-14dd974ca258",
    "storage_key": "property/6767906449166323/019d0268-baa7-7712-9065-14dd974ca258.webp",
    "width": 288,
    "height": 126
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0268-a601-748a-bf79-a1d6a1790e27.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION Management logo.",
    "public_id": "019d0268-a601-748a-bf79-a1d6a1790e27",
    "storage_key": "property/6767906449166323/019d0268-a601-748a-bf79-a1d6a1790e27.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0268-b3b8-7443-a48f-3b60c70bfcec.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Iron Ridge & Stonegate Apartments logo",
    "public_id": "019d0268-b3b8-7443-a48f-3b60c70bfcec",
    "storage_key": "property/6767906449166323/019d0268-b3b8-7443-a48f-3b60c70bfcec.webp",
    "width": 288,
    "height": 126
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0268-baa7-7712-9065-14dd974ca258.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Iron Ridge & Stonegate Apartments logo",
    "public_id": "019d0268-baa7-7712-9065-14dd974ca258",
    "storage_key": "property/6767906449166323/019d0268-baa7-7712-9065-14dd974ca258.webp",
    "width": 288,
    "height": 126
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "929 - 1292",
  "property_sqft_min": "750",
  "property_sqft_max": "1,362",
  "property_price_range": "2409",
  "property_price_min": null,
  "property_price_max": "2409",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/stonegateatironridge",
  "property_instagram_url": "https://www.instagram.com/ironridgestonegate/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJR4BA7zupx4kROZ6MLfaSqCw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/stonegate-apartment-homes-by-greystar-elkton",
  "property_tiktok_url": "https://www.tiktok.com/@stonegateironridge",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Iron Ridge and Stonegate Apartments",
  "property_home_romance_title": "Find Your Heart’s Home in Our Charming Community",
  "property_home_amenities_blurb": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD, where your ideal home awaits. Choose from stylish one, two, or three-bedroom layouts featuring modern amenities like granite countertops, a refreshing pool, and vibrant resident activities. Unwind on your patio or enjoy the dog park—comfort and convenience come together here.",
  "property_home_floorplans_blurb": "Welcome to Iron Ridge and Stonegate Apartments in scenic Elkton, MD, where comfort meets style. Our diverse floor plans—spanning one, two, and three bedrooms—offer the perfect backdrop for your lifestyle. Browse our available apartment homes today and uncover the ideal space that suits your unique needs!",
  "property_home_gallery_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, comfort meets community. Choose from stylish one, two, or three-bedroom floor plans brimming with modern amenities like a sparkling swimming pool, fitness center, and vibrant resident activities. Embrace a lifestyle where every day feels like a retreat. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD — where comfort meets convenience. Nestled near scenic parks, esteemed schools, and vibrant cultural spots like the Elk River Brewing Company and Milburn Stone Theatre, your new home offers an enriching lifestyle amidst nature and community. Dive into local favorites today!",
  "property_home_reviews_blurb": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD, where our residents rave about the prompt, professional management and the vibrant community spirit. One resident shares, “Everyone from Leasing to Maintenance have been fantastic!” Join us today and experience the warmth of our welcoming neighborhood!",
  "property_neighborhood_blurb": "Nestled in the heart of Elkton, Iron Ridge and Stonegate Apartments offer unparalleled access to vibrant points of interest. Enjoy culture at Elkton Music Hall, unwind at Fair Hill State Natural Resources Management Area, or thrive with top-notch education nearby at multiple schools and Cecil College. Experience your ideal neighborhood lifestyle!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, your ideal home awaits. Choose from one to three-bedroom layouts with stunning finishes, all surrounded by vibrant amenities. Enjoy a refreshing swim, engage in resident activities, or unwind on your private patio—life here elevates your every day. Join us today!",
  "property_applynow_blurb": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD—where comfort meets lifestyle. Choose from spacious one, two, or three-bedroom units, complete with modern amenities like a fitness center, swimming pool, and vibrant resident activities. Elevate your living experience; lease your new home online today!",
  "property_contactus_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, we offer a variety of floor plans tailored to your lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. Each home is designed with comfort and style in mind. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Curious about our community? Our FAQs page is your go-to resource for insights and answers. Dive in and enhance your apartment living experience today!",
  "property_floorplans_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, we offer thoughtfully designed floor plans to suit every lifestyle. From cozy one-bedroom retreats to spacious three-bedroom havens, each layout is crafted for comfort. Browse our available apartment homes today and find the ideal floor plan that feels like home.",
  "property_gallery_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, our community blends comfort with vibrant amenities. Imagine barbecuing with friends, unwinding by the pool, or enjoying a game in the resident lounge. With flexible leasing and pet-friendly options, it's not just an apartment—it's your next home. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD, where modern living meets relaxation. Choose from spacious one, two, and three-bedroom floor plans, each featuring sleek granite finishes and inviting patios. Enjoy top-notch amenities, from a sparkling swimming pool to a vibrant dog park. Begin your new chapter today using our interactive community map!",
  "property_pets_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, your furry friends are family too! Enjoy our pet-friendly community with plenty of space for play and adventure. With a clear pet policy, you’ll know exactly what to expect, ensuring a seamless move-in for you and your beloved companions.",
  "property_referafriend_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, spacious one, two, and three-bedroom floor plans await. Great friends make great neighbors—invite your friends to experience the comfort and community you love. Refer a friend today and unlock a vibrant lifestyle together in your new home!",
  "property_residentaccess_blurb": "Welcome to Iron Ridge and Stonegate Apartments in charming Elkton, MD, where a perfect fit awaits with our diverse floor plans: one, two, or three bedrooms. Enjoy seamless living by accessing our resident portal to pay rent, schedule maintenance, and unlock a world of convenience tailored just for you!",
  "property_reviews_blurb": "At Iron Ridge and Stonegate Apartments in Elkton, MD, residents appreciate the vibrant community spirit and dedicated management. One resident joyfully shares, \"Everyone from Leasing to Maintenance have been fantastic!!\" Whether you're enjoying planned events or making friends with neighbors, you'll find a welcoming atmosphere that feels like home.",
  "property_created_at": "1757006324583",
  "property_scheduletour_blurb": "Nestled in the heart of Elkton, MD, Iron Ridge and Stonegate Apartments offers spacious one, two, and three-bedroom floor plans designed for modern living. Experience vibrant community life and unparalleled comfort. Curious about our residents' experiences? Schedule a tour today and hear their stories firsthand!",
  "property_thankyou_blurb": "Thank you for reaching out! At Iron Ridge and Stonegate Apartments in Elkton, MD, we offer a variety of floor plans to fit your lifestyle—choose from cozy one-bedroom to spacious three-bedroom layouts. Stay tuned as our team connects with you to help find your perfect home!",
  "property_virtualtours_blurb": "Step into your dream home at Iron Ridge and Stonegate Apartments in scenic Elkton, MD. Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Experience the charm of our community firsthand—take a virtual tour today and imagine the possibilities of your new lifestyle!",
  "property_copyright": "2025 All Rights Reserved. Iron Ridge and Stonegate Apartments",
  "property_seo_title_home": "Iron Ridge and Stonegate Apartments | Elkton, MD",
  "property_seo_description_home": "Iron Ridge & Stonegate Apts in Elkton, MD near the University of Delaware, Christiana Hospital, Christiana Mall, I-95, Wilmington & Baltimore major employers.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Elkton, MD | Floor Plans",
  "property_seo_description_floorplans": "Spacious 1–3 bedroom apartments in Elkton, MD with luxury amenities. Near University of Delaware, Christiana Mall, and major employers along the I-95 corridor.",
  "property_seo_title_amenities": "Amenities | Elkton Apartments Near I-95 & Newark",
  "property_seo_description_amenities": "Enjoy pools, fitness center, dog parks, courts, garages, and WiFi at Elkton, MD apartments near University of Delaware, I-95, Amazon, and ChristianaCare.",
  "property_seo_title_gallery": "Gallery | Apartments Near Newark DE & Wilmington Jobs",
  "property_seo_description_gallery": "Explore photos of Iron Ridge & Stonegate pet-friendly apartments near the University of Delaware, ChristianaCare hospitals, parks and local dining.",
  "property_seo_title_virtualtours": "Virtual Tours | Iron Ridge and Stonegate Apartments",
  "property_seo_description_virtualtours": "Take a virtual tour of Iron Ridge & Stonegate near the University of Delaware, Christiana Mall, Fair Hill and Newark DE dining, and find our luxury amenities.",
  "property_seo_title_interactivemap": "Interactive Map | Iron Ridge and Stonegate Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Iron Ridge and Stonegate Apartments in Elkton, MD! Use our interactive map to explore spacious layouts and vibrant amenities.",
  "property_seo_title_neighborhood": "Neighborhood |Pet- Friendly Apartments Near Newark, MD",
  "property_seo_description_neighborhood": "Live near Newark, and I-95 with access to the University of Delaware, Amazon, and ChristianaCare in Elkton, MD in our 1, 2 & 3 bedroom apartments for rent.",
  "property_seo_title_contact": "Contact The Best Apartments in Elkton | Iron Ridge",
  "property_seo_description_contact": "Contact Iron Ridge at Stonegate in Elkton near Newark, I-95, and ChristianaCare. Learn more about our 1, 2 & 3 bedroom apartments.",
  "property_seo_title_faqs": "FAQs | Apartments in Elkton, MD",
  "property_seo_description_faqs": "Get the answers you need at Iron Ridge and Stonegate Apartments! Visit our FAQs for insights on amenities, floor plans, and community life in Elkton, MD.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Elkton, MD",
  "property_seo_description_reviews": "Uncover the charm of Iron Ridge and Stonegate Apartments in Elkton, MD. See what our residents love about luxurious amenities and vibrant living experiences!",
  "property_seo_title_applynow": "Apply for Apartments for rent in Elkton, MD Near I-95",
  "property_seo_description_applynow": "Apply online for Iron Ridge & Stonegate in Elkton, MD near University of Delaware, Christiana Mall, Newark DE, restaurants, and Wilmington employment centers.",
  "property_seo_title_residentaccess": "Resident Access | Iron Ridge and Stonegate Apartments",
  "property_seo_description_residentaccess": "Access your Iron Ridge and Stonegate resident portal in Elkton, MD. Pay rent, schedule maintenance, and manage your home—all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | Iron Ridge and Stonegate Apartments",
  "property_seo_description_referafriend": "Refer a friend to Iron Ridge and Stonegate Apartments in Elkton, MD! Great friends make great neighbors—share the joy of vibrant living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Iron Ridge and Stonegate Apartments",
  "property_seo_description_scheduletour": "Schedule a tour of Elkton apartments near University of Delaware, Amazon, and I-95. Visit our 1, 2 & 3 bedroom homes today.",
  "property_seo_title_privacy": "Privacy Policy | Iron Ridge and Stonegate Apartments",
  "property_seo_description_privacy": "At Iron Ridge and Stonegate Apartments in Elkton, MD, your privacy matters. Learn how we safeguard your information in our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Accessibility | Iron Ridge and Stonegate Apartments",
  "property_seo_description_accessibility": "At Iron Ridge and Stonegate Apartments in Elkton, MD, we prioritize accessibility for all. Experience inclusive living that truly welcomes everyone.",
  "property_seo_title_sitemap": "Sitemap | Iron Ridge and Stonegate Apartments",
  "property_seo_description_sitemap": "Navigate your way to comfort at Iron Ridge and Stonegate Apartments in Elkton, MD. Check out our sitemap for easy access to all amenities and floor plans!",
  "property_seo_title_thankyou": "Thank You | Iron Ridge and Stonegate Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to exceptional living at Iron Ridge & Stonegate Apartments in Elkton, MD, is about to begin! Stay tuned for our reply.",
  "property_seo_title_pets": "Pet Policy | Apartments in Elkton, MD",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293668808",
  "amenities": [
    {
      "id": "custom_dbfc9542-14ee-4ffa-be72-f59747078e79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8894a23d-7379-49ca-9e1e-04ab0315bdb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27ec4e00-d90a-455b-946c-cf539995043b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Lounge",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbcd1395-bde5-48db-a120-10d92d22f11f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ee594cf-1724-46c6-a8bd-a5c8639b8155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests and Rent Payment",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae39aeb2-c0ba-4d1b-a4ce-c0896a97090c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c15fea6d-8652-4aa5-b7c1-da5d46e09b9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c717c2b-08b6-4288-b22d-0afc1c961d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3a7219b-b83b-4a77-835e-d4f140895794",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi in Common Areas",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55808735-4200-4410-b950-c91439d8971a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d3011d0-be86-42ff-9ec0-8b2ec7310276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d072511-f60d-4f77-ade7-9aa1a76b288c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca6da470-f8b5-4714-a57c-173ba964efba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f787dc55-a3a3-42fb-87f8-cfa3244173ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Fireplaces Available*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_540d42be-2356-411e-a22b-213a90d73272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "High Ceilings*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbd80f6d-21fa-4aff-a3cd-d94a15d67c48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Available",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9305866f-73d7-436d-9bb2-f50d8646aa51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Paneled Doors*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31aa618a-876c-4bd0-8075-7725ed1825c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrance",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07914229-1f61-4ae2-9406-b15365fa5e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8526751-4e0a-4345-8c0f-77c48166a77e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d6c9846-a8a5-46f2-8170-18a4a3219750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3977efa8-2a4f-44ec-b8b6-0261681151d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Less than 3 miles to University of Delaware",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ae6597b-50e8-443f-b13d-59f6b5bce0dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to I-95 for Easy Commuting to Wilmington, Baltimore, and Philadelphia",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aed0998f-6c8f-45f7-8f1d-2c140170c13d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39d90298-adab-4064-8671-f36afed16115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Garage Parking Available",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa81cc54-534e-4e8d-a5a7-ccb02e210776",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling and Picnic Areas Throughout",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bfd4180-e930-4a11-8a68-8ce0914f7218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5a2f190-7a7e-43b4-ad20-15814ca55caf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c51eacd-ad41-41d9-92ab-ea5ff3fd882d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6c489cc-a3c4-4ee0-8284-9f2bc651917e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Two Dog Parks",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6770d5d9-a382-4270-b43a-55aba47710b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Two Playgrounds",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef5824f4-2c53-42be-b259-cc5695b98091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Two Swimming Pools with Sundecks",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34e0242c-f8a1-4e26-a777-2a1cce2549e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "external_id": "false",
      "title": "Scenic Community Pond",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d7aad6ab-8f44-4047-a0b2-63583679c2a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-81d1-7213-a450-d87b0b4bceca.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fcdfe-81d1-7213-a450-d87b0b4bceca",
        "storage_key": "property/6767906449166323/019fcdfe-81d1-7213-a450-d87b0b4bceca.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a sleek countertop.",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless steel appliances and marble-pattern countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/cb15e0ac3ed6c2dc0fd430a7fa19b8c4.jpg"
    },
    {
      "id": "custom_4324001f-efe8-4578-ad36-61afa74a648b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-81b0-76e1-b7c7-5b0ab3e25645.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink.",
        "public_id": "019fcdfe-81b0-76e1-b7c7-5b0ab3e25645",
        "storage_key": "property/6767906449166323/019fcdfe-81b0-76e1-b7c7-5b0ab3e25645.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Galley-style kitchen with white cabinets, marble-like countertops, stainless appliances, and a window for natural light.",
      "link": "false",
      "alt_text": "Bright galley kitchen with white cabinets, stainless steel appliances, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/672d268a5d353df14caf0a0848c494e3.jpg"
    },
    {
      "id": "custom_dcdc23a5-2fcf-4fb5-9405-32531a67cb86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-8189-725f-8a07-6e0783b6adef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019fcdfe-8189-725f-8a07-6e0783b6adef",
        "storage_key": "property/6767906449166323/019fcdfe-8189-725f-8a07-6e0783b6adef.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen in a contemporary apartment featuring white shaker cabinets, quartz countertops, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with white cabinets, quartz countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/c567e206d1cf62b572f6e12c8230f3c0.jpg"
    },
    {
      "id": "custom_c15dcbc5-cd93-4f23-835c-b5555705d9d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-81c0-72ff-a02a-272b4c23b8da.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large sink.",
        "public_id": "019fcdfe-81c0-72ff-a02a-272b4c23b8da",
        "storage_key": "property/6767906449166323/019fcdfe-81c0-72ff-a02a-272b4c23b8da.webp",
        "width": 1752,
        "height": 1169
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen featuring granite counters, a large sink, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/59e8babbaa2dbdfcbf94bea74f59f011.jpg"
    },
    {
      "id": "custom_4e00b740-4d25-49f1-b75f-c4b0b07213aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-8b4a-7292-b212-b10409a0c513.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceilings, a sectional sofa, coffee table, armchair, fireplace, and mounted TV.",
        "public_id": "019fcdfe-8b4a-7292-b212-b10409a0c513",
        "storage_key": "property/6767906449166323/019fcdfe-8b4a-7292-b212-b10409a0c513.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring vaulted ceilings, a cozy fireplace, and ample space for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Bright living room with a beige sofa, armchair, fireplace, and large windows with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/dc7dee51c0dd2cec05901567029d5b70.jpg"
    },
    {
      "id": "custom_e655e3d4-5884-45ac-a2b6-76a20510c57b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-8c3a-7271-9704-b652df15de50.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and armchair, opening to a kitchen.",
        "public_id": "019fcdfe-8c3a-7271-9704-b652df15de50",
        "storage_key": "property/6767906449166323/019fcdfe-8c3a-7271-9704-b652df15de50.webp",
        "width": 1752,
        "height": 1169
      },
      "title": "Apartment",
      "description": "Spacious living area with a fireplace and open-concept kitchen, ideal for entertaining in this apartment.",
      "link": "false",
      "alt_text": "Living room in an apartment with a fireplace, mounted TV, and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/dda880a5a0f621391e30db4985808a51.jpg"
    },
    {
      "id": "custom_fa316261-0eb7-425d-b1b9-3538a9949df4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-8c87-71ad-9a4b-f247faf1fbba.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and decorative items.",
        "public_id": "019fcdfe-8c87-71ad-9a4b-f247faf1fbba",
        "storage_key": "property/6767906449166323/019fcdfe-8c87-71ad-9a4b-f247faf1fbba.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a stylish coffee table, and elegant decor, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7897_12-03-26_13_36.jpg"
    },
    {
      "id": "custom_73c8bb4d-0217-48bc-b700-a7fe949de49d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-8ec3-708e-9ba8-61e70a639f96.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and a sliding glass door leading to a balcony.",
        "public_id": "019fcdfe-8ec3-708e-9ba8-61e70a639f96",
        "storage_key": "property/6767906449166323/019fcdfe-8ec3-708e-9ba8-61e70a639f96.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern coffee table, and a bright sliding glass door that opens to a private balcony, perfect for relaxing.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7892_12-03-26_13_37.jpg"
    },
    {
      "id": "custom_80e11dad-374f-47b8-aa14-e7062421e407",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-96d8-73a4-9fbf-8cd521f0f26f.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, dining table, and fireplace.",
        "public_id": "019fcdfe-96d8-73a4-9fbf-8cd521f0f26f",
        "storage_key": "property/6767906449166323/019fcdfe-96d8-73a4-9fbf-8cd521f0f26f.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a cozy fireplace and comfortable seating.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, dining table, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_6093_17-03-26_10_12.jpg"
    },
    {
      "id": "custom_736f0780-db9e-4448-85cc-51766a75de6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-9703-763e-86d6-5730989747fb.webp",
      "image_media": {
        "alt_text": "Dining area with oval table and chairs, fireplace, and large clock.",
        "public_id": "019fcdfe-9703-763e-86d6-5730989747fb",
        "storage_key": "property/6767906449166323/019fcdfe-9703-763e-86d6-5730989747fb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegant dining area, featuring a spacious oval table, comfortable seating, a cozy fireplace, and a stylish wall clock.",
      "link": "false",
      "alt_text": "Dining area with oval table and chairs, fireplace, and large clock.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_iron_ridge_0006_DSC_6087_17-03-26_10_13.jpg"
    },
    {
      "id": "custom_ee6c914c-b98d-4fbf-b7a0-303ead612188",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-991d-74a8-b3f3-afa53c1751f9.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, armchair, and open kitchen.",
        "public_id": "019fcdfe-991d-74a8-b3f3-afa53c1751f9",
        "storage_key": "property/6767906449166323/019fcdfe-991d-74a8-b3f3-afa53c1751f9.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a gray sofa, accent armchair, and an open kitchen with modern appliances. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, armchair, and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7815_13-03-26_15_54.jpg"
    },
    {
      "id": "custom_517ae1e5-0317-4355-a55a-f119439f63e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-9a17-743e-b752-208542a609e8.webp",
      "image_media": {
        "alt_text": "Dining area and open-concept kitchen with white cabinets and stainless steel appliances.",
        "public_id": "019fcdfe-9a17-743e-b752-208542a609e8",
        "storage_key": "property/6767906449166323/019fcdfe-9a17-743e-b752-208542a609e8.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area adjacent to a modern kitchen featuring white cabinets and stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Dining area and open-concept kitchen with white cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7820_14-03-26_16_16.jpg"
    },
    {
      "id": "custom_c477b180-7e0f-4022-ae5e-51103d170f79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-a2d5-751e-9a73-8fd76347f4d9.webp",
      "image_media": {
        "alt_text": "Dining area and living room with open-concept kitchen.",
        "public_id": "019fcdfe-a2d5-751e-9a73-8fd76347f4d9",
        "storage_key": "property/6767906449166323/019fcdfe-a2d5-751e-9a73-8fd76347f4d9.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Enjoy meals and relaxation in this beautifully appointed living and dining area, featuring an open-concept kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Dining area and living room with open-concept kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_5899_13-03-26_16_43.jpg"
    },
    {
      "id": "custom_68957145-7be5-4315-98a8-4079e23c4c06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-a420-7041-895a-041612041915.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, adjacent to an open kitchen.",
        "public_id": "019fcdfe-a420-7041-895a-041612041915",
        "storage_key": "property/6767906449166323/019fcdfe-a420-7041-895a-041612041915.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish dining area featuring a round wooden table and four upholstered chairs, seamlessly connecting to an open-concept kitchen with modern appliances.",
      "link": "false",
      "alt_text": "Dining area with a round table and four chairs, adjacent to an open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_iron_ridge_0019_DSC_6031_12-03-26_13_15.jpg"
    },
    {
      "id": "custom_177b939d-9d28-49d4-b571-d950124cf296",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-a757-74ba-b18c-8ce78d24b9da.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside tables, and a large window.",
        "public_id": "019fcdfe-a757-74ba-b18c-8ce78d24b9da",
        "storage_key": "property/6767906449166323/019fcdfe-a757-74ba-b18c-8ce78d24b9da.webp",
        "width": 1280,
        "height": 838
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern bedside tables, and ample natural light from a large window. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, bedside tables, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7911_12-03-26_13_18.jpg"
    },
    {
      "id": "custom_89c46db2-8a58-4d4a-bb42-06bb35a236ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-a9e3-7439-8bdc-5aa59a7a1266.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, a bed, and a closet.",
        "public_id": "019fcdfe-a9e3-7439-8bdc-5aa59a7a1266",
        "storage_key": "property/6767906449166323/019fcdfe-a9e3-7439-8bdc-5aa59a7a1266.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable bed, a modern dresser, and ample closet space. The room is well-lit and inviting.",
      "link": "false",
      "alt_text": "Bedroom with a dresser, a bed, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_6105_12-03-26_14_38.jpg"
    },
    {
      "id": "custom_a1808aad-d58a-4333-af8a-5effbfe52aa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-aea6-760b-9f16-4e57564302b1.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and window.",
        "public_id": "019fcdfe-aea6-760b-9f16-4e57564302b1",
        "storage_key": "property/6767906449166323/019fcdfe-aea6-760b-9f16-4e57564302b1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with crisp white linens, a modern dresser, and a large window offering natural light. The room is elegantly decorated with a piece of abstract art.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a large window, bed, dresser, and plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/f52aaadbf269d5ac9b66115bae26e15d.jpg"
    },
    {
      "id": "custom_ce083fab-8017-40b8-9107-a9ac8b556e58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-af98-70ed-9f25-6213b94cdf0b.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, closet doors, and a window.",
        "public_id": "019fcdfe-af98-70ed-9f25-6213b94cdf0b",
        "storage_key": "property/6767906449166323/019fcdfe-af98-70ed-9f25-6213b94cdf0b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, neutral bedroom in a modern apartment with a bed, dresser, and dual closet doors.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, dresser, double closet doors, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/265151a56f34481a33341fd75e0ae290.jpg"
    },
    {
      "id": "custom_1c330cf7-00b6-4750-a927-ff6f86a9c281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-b45a-708f-aebe-14dad22be774.webp",
      "image_media": {
        "alt_text": "Home office with a desk, chair, computer, and decor.",
        "public_id": "019fcdfe-b45a-708f-aebe-14dad22be774",
        "storage_key": "property/6767906449166323/019fcdfe-b45a-708f-aebe-14dad22be774.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Create your ideal home office in this spacious and bright room, perfect for productive work or creative pursuits.",
      "link": "false",
      "alt_text": "Home office with a desk, chair, computer, and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/Iron_Ridge_Stonegate_3.12.26_DSC_7871_12-03-26_14_47.jpg"
    },
    {
      "id": "custom_7f6939e3-dfc4-4d2b-a15b-e9c700247c45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-b62b-739d-bb0f-d7983d895d9f.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a white vanity, sink, toilet, and bathtub with a shower curtain.",
        "public_id": "019fcdfe-b62b-739d-bb0f-d7983d895d9f",
        "storage_key": "property/6767906449166323/019fcdfe-b62b-739d-bb0f-d7983d895d9f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Clean apartment bathroom featuring a tub/shower, single-sink vanity, mirrored cabinet, and neutral finishes.",
      "link": "false",
      "alt_text": "Bathroom with a tub/shower, toilet, and a vanity with a mirrored medicine cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/991e87fa0c084fb2528021975f442986.jpg"
    },
    {
      "id": "custom_ec40b721-d264-441b-9dab-a971b18b9313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-baca-77aa-bf9b-90fddd8698e9.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019fcdfe-baca-77aa-bf9b-90fddd8698e9",
        "storage_key": "property/6767906449166323/019fcdfe-baca-77aa-bf9b-90fddd8698e9.webp",
        "width": 1752,
        "height": 1169
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a white countertop vanity, a wood-framed mirror, toilet, and a tub/shower with a curtain.",
      "link": "false",
      "alt_text": "Bathroom with white vanity, wood-framed mirror, toilet, and tub/shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/758f9c32024f75aa8fba32f403f797d8.jpg"
    },
    {
      "id": "custom_600e4e7f-6ca2-4b8c-b7fc-7885d51351f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-bac9-779d-a453-f5c87c916f58.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white marble countertop, black faucet, and modern light fixture.",
        "public_id": "019fcdfe-bac9-779d-a453-f5c87c916f58",
        "storage_key": "property/6767906449166323/019fcdfe-bac9-779d-a453-f5c87c916f58.webp",
        "width": 1334,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom with a white vanity, marble countertop, and black fixtures.",
      "link": "false",
      "alt_text": "Bathroom vanity with white cabinet, marble countertop, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/d761ccdc65e218c94cf54293ff6394bf.jpg"
    },
    {
      "id": "custom_d47e91b1-758c-4f82-8112-9e6c49340eef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-bf1d-7299-9c2f-a672a7aee0e8.webp",
      "image_media": {
        "alt_text": "White GE top-load washer and Whirlpool dryer in a laundry closet.",
        "public_id": "019fcdfe-bf1d-7299-9c2f-a672a7aee0e8",
        "storage_key": "property/6767906449166323/019fcdfe-bf1d-7299-9c2f-a672a7aee0e8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit laundry area with a white washer and dryer in a compact closet.",
      "link": "false",
      "alt_text": "White top-load washing machine and front-loading dryer in a compact laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/de428209b6ceeba4fab4ce525db0726c.jpg"
    },
    {
      "id": "custom_37bb3ff9-5a1e-43f0-a6e9-d92da3688f40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-c247-739a-8d70-461caf5c178f.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdfe-c247-739a-8d70-461caf5c178f",
        "storage_key": "property/6767906449166323/019fcdfe-c247-739a-8d70-461caf5c178f.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community with lounge seating and umbrellas for residents.",
      "link": "false",
      "alt_text": "Aerial view of an outdoor rectangular pool surrounded by lounge chairs, tables, and orange umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/b6b2e6d2935892f63b69246c80b2be10.webp"
    },
    {
      "id": "custom_6a1b162c-e1f7-4bd3-a10a-7936e9738bee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-c571-721e-ac45-cab4504b6448.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019fcdfe-c571-721e-ac45-cab4504b6448",
        "storage_key": "property/6767906449166323/019fcdfe-c571-721e-ac45-cab4504b6448.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Aerial view of a multifamily property's pool area with lounge chairs and orange umbrellas.",
      "link": "false",
      "alt_text": "Aerial view of a residential community pool with orange umbrellas and lounge chairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/6c14d3284bab9a0673a36984ab619f3c-0adb5b99.jpg"
    },
    {
      "id": "custom_0828af60-f6d3-4ef9-909c-ec618a525c9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-c7b9-73c0-960f-c3cee92e47c0.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machine in apartment complex gym",
        "public_id": "019fcdfe-c7b9-73c0-960f-c3cee92e47c0",
        "storage_key": "property/6767906449166323/019fcdfe-c7b9-73c0-960f-c3cee92e47c0.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Well-equipped community fitness center with cardio machines for residents.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, an elliptical machine, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/1b2ae64e478309b9267b73ce02a129d1.jpg"
    },
    {
      "id": "custom_ff9f30ce-fa67-4cbc-8917-aedb823fe4b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-ca07-754b-8c2e-b7718204b885.webp",
      "image_media": {
        "alt_text": "Fenced-in grassy area with apartment buildings in the background.",
        "public_id": "019fcdfe-ca07-754b-8c2e-b7718204b885",
        "storage_key": "property/6767906449166323/019fcdfe-ca07-754b-8c2e-b7718204b885.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a multi-building apartment community with balconies, green space, and a fenced yard.",
      "link": "false",
      "alt_text": "Exterior view of beige apartment buildings with balconies, a grassy yard, and a chain-link fence under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/116f6bf7f56821f9d8170fc9fcf2da90.jpg"
    },
    {
      "id": "custom_819a6c89-964a-4b98-97a8-3f9e2a2a1e40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-cf9d-744d-bbac-c4b34d9bca29.webp",
      "image_media": {
        "alt_text": "Playground with orange slide and swings on a sunny day",
        "public_id": "019fcdfe-cf9d-744d-bbac-c4b34d9bca29",
        "storage_key": "property/6767906449166323/019fcdfe-cf9d-744d-bbac-c4b34d9bca29.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community playground at the property with bright orange slides and climbing equipment.",
      "link": "false",
      "alt_text": "Orange playground structure with a twisting slide in a fenced community park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/96d7340b7ee75bea650f01045bd87d6f.jpg"
    },
    {
      "id": "custom_3a4928b5-8a13-4546-823d-c9e6d5155cba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-d326-742e-95fc-0547072dba2f.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a fence and trees in the background.",
        "public_id": "019fcdfe-d326-742e-95fc-0547072dba2f",
        "storage_key": "property/6767906449166323/019fcdfe-d326-742e-95fc-0547072dba2f.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our outdoor court, perfect for residents who love to stay active.",
      "link": "false",
      "alt_text": "Outdoor basketball court with hoop, backboard, and chain-link fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/63ae81c113cf1a0c5bc91bfba61a6f86.jpg"
    },
    {
      "id": "custom_e2c7832d-f788-45ae-8a31-bde9f669a9a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-d703-712e-be7e-9628f3075eec.webp",
      "image_media": {
        "alt_text": "Community lounge area with foosball table, lounge seating, and kitchen.",
        "public_id": "019fcdfe-d703-712e-be7e-9628f3075eec",
        "storage_key": "property/6767906449166323/019fcdfe-d703-712e-be7e-9628f3075eec.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Modern resident lounge at Iron Ridge featuring a foosball table, TV, and comfortable seating.",
      "link": "false",
      "alt_text": "Interior community lounge with a foosball table, seating, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/03427bd4fa0bef6688f5904a064077e5.jpg"
    },
    {
      "id": "custom_9e987134-89d6-4f03-8afb-ada758c389ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-d9b9-75a2-b119-8e6986316eec.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, TV, and computer workstations.",
        "public_id": "019fcdfe-d9b9-75a2-b119-8e6986316eec",
        "storage_key": "property/6767906449166323/019fcdfe-d9b9-75a2-b119-8e6986316eec.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious resident lounge with a round table, study desks, computers, and a fireplace—great for gatherings and work.",
      "link": "false",
      "alt_text": "Community lounge with round wooden table, patterned chairs, desks with computers, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/4a5fafc17189bd631549e312288b3305.jpg"
    },
    {
      "id": "custom_0fcf227d-3fb0-4e0d-b22e-9dfecf104e6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-dd8c-70e9-bb01-d8866009da9b.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with sofas and armchairs in a community lounge, featuring a coffee table and a modern chandelier.",
        "public_id": "019fcdfe-dd8c-70e9-bb01-d8866009da9b",
        "storage_key": "property/6767906449166323/019fcdfe-dd8c-70e9-bb01-d8866009da9b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious resident lounge with comfortable seating and an open kitchenette for gatherings.",
      "link": "false",
      "alt_text": "Bright community lounge with neutral seating and a kitchenette in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/707977549e9cb666fbbb7ec88b2230d6.jpg"
    },
    {
      "id": "custom_53309233-5c05-4d43-b790-8b011b0ef8f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-df1b-73ae-bd53-ca48ae9ac139.webp",
      "image_media": {
        "alt_text": "Two green park benches overlook a serene pond surrounded by trees and apartment buildings.",
        "public_id": "019fcdfe-df1b-73ae-bd53-ca48ae9ac139",
        "storage_key": "property/6767906449166323/019fcdfe-df1b-73ae-bd53-ca48ae9ac139.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "A tranquil pond in a residential community, flanked by trees and apartment buildings with seating for residents.",
      "link": "false",
      "alt_text": "Outdoor pond with green benches and trees, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/8ea942b1e0931957f65afe80025819cf.jpg"
    },
    {
      "id": "custom_f63b4c62-64cb-414b-9e9c-a2647b5b39e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-e1a1-747f-9174-b0d061fd0d60.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "019fcdfe-e1a1-747f-9174-b0d061fd0d60",
        "storage_key": "property/6767906449166323/019fcdfe-e1a1-747f-9174-b0d061fd0d60.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming apartment buildings with attractive brick and siding exteriors, surrounded by lush green lawns and well-maintained landscaping, offering a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of a multi-unit apartment building with brick accents and manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/27b9946e/dms3rep/multi/5767906449162442/6767906449166323/d09a61b7fd2d169b46a59c1db53c42a2.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_255713d0-95c8-485e-8a84-23dfaa826648",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Legends on Main",
      "poi_type": "Restaurants",
      "poi_address": "102 W Main St, Elkton, MD 21921, USA",
      "poi_short_description": "Cozy cafe offering breakfast and lunch staples, plus mimosas, wine, and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f2e1-7379-a8fb-60f930cc5776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f2e1-7379-a8fb-60f930cc5776",
        "storage_key": "property/6767906449166323/019fcdfe-f2e1-7379-a8fb-60f930cc5776.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elktonlegends.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13191896571800149967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legends-on-main",
      "poi_latitude": "39.6076555",
      "poi_longitude": "-75.82986249999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 443-593-3775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86bb-730e-a7ee-15ee23e7dc3b",
        "storage_key": "property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJT2a2eF2vx4kRz1_X0wkIE7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1da00536-04f0-45fc-831d-f87800ccf1d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "300 Belle Hill Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f2e6-733e-9601-a501c24a558a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f2e6-733e-9601-a501c24a558a",
        "storage_key": "property/6767906449166323/019fcdfe-f2e6-733e-9601-a501c24a558a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/md/elkton/472/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=3227866573410314403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.6369011",
      "poi_longitude": "-75.8043201",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-620-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XmQctWox4kRo6h66ouvyyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f4ee50fb-eb9e-447c-9764-b436c2eab257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "261 Belle Hill Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f353-765c-93fa-3afc992c7bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f353-765c-93fa-3afc992c7bf7",
        "storage_key": "property/6767906449166323/019fcdfe-f353-765c-93fa-3afc992c7bf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.wafflehouse.com/elkton-md-1331",
      "poi_directions_map_url": "https://maps.google.com/?cid=5960798112897446728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "39.6355116",
      "poi_longitude": "-75.80538709999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 410-620-5630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6pxItWox4kRSDMSUU0CuVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5c71d9f8-0f1b-4970-8673-676add145816",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "101 W Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f348-732e-b401-f57116a61864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f348-732e-b401-f57116a61864",
        "storage_key": "property/6767906449166323/019fcdfe-f348-732e-b401-f57116a61864.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1023272",
      "poi_directions_map_url": "https://maps.google.com/?cid=6950667402857323052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "39.60105",
      "poi_longitude": "-75.82854999999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-996-1004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86bb-730e-a7ee-15ee23e7dc3b",
        "storage_key": "property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ3zv5a-2vx4kRLJoyOy27dWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a050c699-dd0c-4923-8ee2-e379532305e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "102 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f800-70d9-ab9f-0084c19813c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f800-70d9-ab9f-0084c19813c2",
        "storage_key": "property/6767906449166323/019fcdfe-f800-70d9-ab9f-0084c19813c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/md/elkton/102-big-elk-mall/303438?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=303438&y_source=1_MTIxMDYzMzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4005370484371973793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "39.6006086",
      "poi_longitude": "-75.82599549999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 410-392-0183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86bb-730e-a7ee-15ee23e7dc3b",
        "storage_key": "property/6767906449166323/019d0266-86bb-730e-a7ee-15ee23e7dc3b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJG93EDF-vx4kRoWbT8jvvlTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a1f19455-c5e1-41ae-a66b-6ab15c6d8e38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "121 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_long_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f99c-734d-af29-8f28cb5b3e99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f99c-734d-af29-8f28cb5b3e99",
        "storage_key": "property/6767906449166323/019fcdfe-f99c-734d-af29-8f28cb5b3e99.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://www.dominos.com/en/?utm_source=google&utm_medium=loclist&utm_campaign=localmaps_menutest",
      "poi_directions_map_url": "https://maps.google.com/?cid=11270945755102670202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "39.6006266",
      "poi_longitude": "-75.82432109999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 443-246-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSP52Yqvx4kRem2Xv3Jxapw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b9b37ef-f23a-4e9a-b14e-1c31a4049b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Popeyes Louisiana Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "106 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_long_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-f978-778f-a112-22cdb3da4149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-f978-778f-a112-22cdb3da4149",
        "storage_key": "property/6767906449166323/019fcdfe-f978-778f-a112-22cdb3da4149.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.popeyes.com/store-locator/store/restaurant_81789",
      "poi_directions_map_url": "https://maps.google.com/?cid=5876747956472398681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popeyes-louisiana-kitchen",
      "poi_latitude": "39.5996594",
      "poi_longitude": "-75.8246411",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 410-392-2296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG93EDF-vx4kRWUMKTCFnjlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_320e5d95-18fe-47c7-8efc-89ce00011110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Tropical Smoothie Cafe, Elkton",
      "poi_type": "Restaurants",
      "poi_address": "108 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-fa00-753d-bb8e-249468726150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-fa00-753d-bb8e-249468726150",
        "storage_key": "property/6767906449166323/019fcdfe-fa00-753d-bb8e-249468726150.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/md/elkton/108-big-elk-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=15734742743104849719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-smoothie-cafe-elkton",
      "poi_latitude": "39.5995788",
      "poi_longitude": "-75.8240022",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 667-215-0329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDhGA-vx4kRN4frmigJXdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66270fde-e698-42ad-802c-50e7a73ffb79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "BnB Seafood",
      "poi_type": "Restaurants",
      "poi_address": "1540 Elkton Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Takeout spot offering a variety of crab dishes and other seafood eats along with fried oreos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-ff48-7044-a922-3fa1a657ec5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-ff48-7044-a922-3fa1a657ec5d",
        "storage_key": "property/6767906449166323/019fcdfe-ff48-7044-a922-3fa1a657ec5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bnbseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6878844446455476139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bnb-seafood",
      "poi_latitude": "39.6471408",
      "poi_longitude": "-75.7951793",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 410-398-8089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLd3DZfOpx4kRq68lEJSQdl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_504d4b99-6d20-49b5-b942-b5e5ab212e09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Mick's Pub & Crabs (Micks Crab House)",
      "poi_type": "Restaurants",
      "poi_address": "902 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Comfy joint offering all-you-can-eat crabs & other seafood, with a full bar & live entertainment.",
      "poi_long_description": "Comfy joint offering all-you-can-eat crabs & other seafood, with a full bar & live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0031-7237-aca1-897c3ce21b09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0031-7237-aca1-897c3ce21b09",
        "storage_key": "property/6767906449166323/019fcdff-0031-7237-aca1-897c3ce21b09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mickspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18231922583760501630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "micks-pub--crabs-micks-crab-house",
      "poi_latitude": "39.6033333",
      "poi_longitude": "-75.7952778",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 443-485-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZA8gK-ox4kRfnt3Of7MBP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_67dbcd1f-622d-4fe8-94ab-d67e23166a9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1195 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0011-768a-b292-fed55d6f86fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0011-768a-b292-fed55d6f86fb",
        "storage_key": "property/6767906449166323/019fcdff-0011-768a-b292-fed55d6f86fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/maryland/elkton/elkton?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=3939065489832004908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "39.60577",
      "poi_longitude": "-75.79102499999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 410-620-3165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsV8FzKSox4kRLM1vZDFfqjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2987923-5bda-49cb-a4b5-d951042f441a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "221 Belle Hill Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdfe-ffcf-77ae-8e8f-900685c77dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfe-ffcf-77ae-8e8f-900685c77dcc",
        "storage_key": "property/6767906449166323/019fcdfe-ffcf-77ae-8e8f-900685c77dcc.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/979/golden-corral-belle-hill-rd?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=979",
      "poi_directions_map_url": "https://maps.google.com/?cid=962148633749928357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "39.6382825",
      "poi_longitude": "-75.8063018",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 410-398-9193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7ZrZdWux4kRpbnKrxU9Wg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cacada21-6995-461e-9370-69b13bf08171",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Sabor Latino",
      "poi_type": "Restaurants",
      "poi_address": "801 E Pulaski Hwy #127, Elkton, MD 21921, USA",
      "poi_short_description": "Casual Mexican restaurant dishing up tacos, tortas, and other specialties, plus beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-058c-7428-af3f-29ef32d1361e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-058c-7428-af3f-29ef32d1361e",
        "storage_key": "property/6767906449166323/019fcdff-058c-7428-af3f-29ef32d1361e.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17125469800705335211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sabor-latino",
      "poi_latitude": "39.6025875",
      "poi_longitude": "-75.8032257",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 443-485-6684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFe8hcayox4kRq5-4kgzkqe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c119452-5c86-4435-933d-b72c7cf8d634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Happy Panda",
      "poi_type": "Restaurants",
      "poi_address": "801 E Pulaski Hwy #123, Elkton, MD 21921, USA",
      "poi_short_description": "Casual restaurant serving a menu of Chinese and Thai dishes including vegetarian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0690-73ab-9399-eca03bedb26b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0690-73ab-9399-eca03bedb26b",
        "storage_key": "property/6767906449166323/019fcdff-0690-73ab-9399-eca03bedb26b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.happypandamd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16531643368284820718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-panda",
      "poi_latitude": "39.6025407",
      "poi_longitude": "-75.8034004",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-392-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86fc-77fa-80dc-000d8a94e911",
        "storage_key": "property/6767906449166323/019d0266-86fc-77fa-80dc-000d8a94e911.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8-LmLGox4kR7hQPGA4ybOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4894172e-8333-451a-9a28-b4d56617bbd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Minihane's Irish Pub and Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "101 W Main St, Elkton, MD 21921, USA",
      "poi_short_description": "Festive pub with an ample whiskey menu serving up traditional Irish fare in an inviting corner site.",
      "poi_long_description": "Festive pub with an ample whiskey menu serving up traditional Irish fare in an inviting corner site.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-071a-756d-b7e1-f53774376a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-071a-756d-b7e1-f53774376a90",
        "storage_key": "property/6767906449166323/019fcdff-071a-756d-b7e1-f53774376a90.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5711371326120692495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minihanes-irish-pub-and-restaurant",
      "poi_latitude": "39.6077535",
      "poi_longitude": "-75.83010829999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 410-996-0047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8701-7127-81a6-30d323af5974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8701-7127-81a6-30d323af5974",
        "storage_key": "property/6767906449166323/019d0266-8701-7127-81a6-30d323af5974.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk0s_f12vx4kRD4vGAfbdQk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cb582346-fe28-46fd-8e1f-048fbb4c0959",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping",
      "poi_address": "101 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "Neighborhood grocery store offering fresh produce, baked goods, and meats, plus pickup and delivery options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0667-773b-ba7f-fb52e5a5c703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0667-773b-ba7f-fb52e5a5c703",
        "storage_key": "property/6767906449166323/019fcdff-0667-773b-ba7f-fb52e5a5c703.webp",
        "width": 1088,
        "height": 612
      },
      "poi_business_url": "https://local.acmemarkets.com/md/elkton/101-big-elk-mall.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12856761971101840015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "39.6016669",
      "poi_longitude": "-75.82616519999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-398-4925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b26-75ff-bb9c-b3a1cdce3817",
        "storage_key": "property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG93EDF-vx4kRj7JGCeVkbLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3370ce5a-0577-432a-b62a-742623d74cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping",
      "poi_address": "1001 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Supermarket stocking fruit, vegetables, meats, seafood and baked goods, plus prepared foods and organic options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0b85-75e6-bf28-b2a14f5ff52c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0b85-75e6-bf28-b2a14f5ff52c",
        "storage_key": "property/6767906449166323/019fcdff-0b85-75e6-bf28-b2a14f5ff52c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.foodlion.com/md/elkton/1001-east-pulaski-hwy?y_source=1_NTA0Njc1Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8607371451012433926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "39.6038944",
      "poi_longitude": "-75.798288",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-620-3664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b26-75ff-bb9c-b3a1cdce3817",
        "storage_key": "property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbEy966ox4kRBkhvG7uGc3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_88a46e40-5073-4393-9fee-7121f913ef71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "1000 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Chain outlet offering a large variety of consumer goods, including groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0ca1-7729-910a-8779fb2f13a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0ca1-7729-910a-8779fb2f13a2",
        "storage_key": "property/6767906449166323/019fcdff-0ca1-7729-910a-8779fb2f13a2.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1860-elkton-md/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17589339310696668364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.6032546",
      "poi_longitude": "-75.7929228",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-398-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMX53AqWox4kRzJzjJ-niGfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0be37760-8082-401e-94c8-ff143b3bd67c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Suburban Plaza",
      "poi_type": "Shopping",
      "poi_address": "2557-2655 Suburban Dr, Newark, DE 19711",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "39.6679229",
      "poi_longitude": "-75.7761917",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_32b4b41a-ef55-4b8d-b9ca-8b4c0b1b41d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping",
      "poi_address": "801 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0d9d-7049-9b1b-611560091fe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0d9d-7049-9b1b-611560091fe8",
        "storage_key": "property/6767906449166323/019fcdff-0d9d-7049-9b1b-611560091fe8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/740?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1098953057009523925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "39.6024553",
      "poi_longitude": "-75.8042036",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 443-350-9136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b26-75ff-bb9c-b3a1cdce3817",
        "storage_key": "property/6767906449166323/019d0266-8b26-75ff-bb9c-b3a1cdce3817.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79Ts4zOpx4kR1dzhm_tDQA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1240eb8a-1091-4969-b5ab-9017ed724641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Ocean State Job Lot",
      "poi_type": "Shopping",
      "poi_address": "801 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Retail chain for household goods, clothing & grocery items at closeout prices.",
      "poi_long_description": "Retail chain for household goods, clothing & grocery items at closeout prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-0d7c-750c-aa3a-fed96cf5441a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-0d7c-750c-aa3a-fed96cf5441a",
        "storage_key": "property/6767906449166323/019fcdff-0d7c-750c-aa3a-fed96cf5441a.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.oceanstatejoblot.com/store-locator/maryland/elkton/653/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9507190798409877962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocean-state-job-lot",
      "poi_latitude": "39.6028688",
      "poi_longitude": "-75.80318489999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 443-229-5270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI1FSrZ6px4kRykkV76hT8IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0626de5-dacf-47a1-92e3-29007b1b355f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "301 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1249-751e-a879-e2e810f054db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1249-751e-a879-e2e810f054db",
        "storage_key": "property/6767906449166323/019fcdff-1249-751e-a879-e2e810f054db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-301+e+pulaski+hwy-elkton-md-21921/id=10977",
      "poi_directions_map_url": "https://maps.google.com/?cid=14507319511993023518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.5987599",
      "poi_longitude": "-75.81872369999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-620-1325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8rz_felx4kRHvxvqztaVMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_53c7ba03-bdd0-40ed-b767-05162f744f65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping",
      "poi_address": "723 N Bridge St, Elkton, MD 21921, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-12b2-760c-8ca5-f50d8580f0e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-12b2-760c-8ca5-f50d8580f0e4",
        "storage_key": "property/6767906449166323/019fcdff-12b2-760c-8ca5-f50d8580f0e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/elkton-md-pharmacies/723-n-bridge-st-elkton-md-21921/storeid=11063?WT.mc_id=LS_GOOGLE_FS_11063",
      "poi_directions_map_url": "https://maps.google.com/?cid=5219221209079693848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.6184759",
      "poi_longitude": "-75.8389327",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-392-2961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWuSrW2vx4kRGEJhewlmbkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5eca89fa-f19c-493b-b160-aa2cf6b7428a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "103 E Pulaski Hwy, Big Elk Mall Suite A, Elkton, MD 21921, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-135f-75bb-afeb-9c7dd33bee5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-135f-75bb-afeb-9c7dd33bee5c",
        "storage_key": "property/6767906449166323/019fcdff-135f-75bb-afeb-9c7dd33bee5c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/md/elkton/103-e-pulaski-hwy-suite-a-big-elk-mall?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323648583645853292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.6006239",
      "poi_longitude": "-75.82484819999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 443-945-9240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnS5cZl-vx4kRbPY4US5m4Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0928bca3-9de9-4e9c-bd87-25e1c08fb836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping",
      "poi_address": "10 Chestnut Dr, Elkton, MD 21921",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "39.654773299999995",
      "poi_longitude": "-75.798935",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8c0d6f8d-0220-4d35-90b0-9b2e2227549f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping",
      "poi_address": "2524 Singerly Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1356-70ac-a2ba-12c46a12dc60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1356-70ac-a2ba-12c46a12dc60",
        "storage_key": "property/6767906449166323/019fcdff-1356-70ac-a2ba-12c46a12dc60.webp",
        "width": 427,
        "height": 640
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/md/elkton/21451",
      "poi_directions_map_url": "https://maps.google.com/?cid=14322930753906315890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "39.6752997",
      "poi_longitude": "-75.85844260000002",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 443-406-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIcRQ9MGvx4kRcpIacaJFxcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a97cf78-d11f-4308-8e09-77c6116f2887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Big Elk Shopping Centre",
      "poi_type": "Shopping",
      "poi_address": "157 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Strip mall featuring a variety of shops, including a gym, fast food, and a grocery store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-188e-746f-9208-67e493fa1e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-188e-746f-9208-67e493fa1e7e",
        "storage_key": "property/6767906449166323/019fcdff-188e-746f-9208-67e493fa1e7e.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://big-elk-shopping.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5607221932482373017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-elk-shopping-centre",
      "poi_latitude": "39.5999255",
      "poi_longitude": "-75.8242008",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-733-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIRM7tlivx4kRmSVkpqPa0E0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9341066a-3e26-41c4-b098-46ab83e143c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil Manor Elementary School",
      "poi_type": "Education",
      "poi_address": "971 Elk Mills Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14760933249722995826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-manor-elementary-school",
      "poi_latitude": "39.6581991",
      "poi_longitude": "-75.8179299",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 410-996-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKdUPDciux4kRctT9dpVe2cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ae3b602-7880-449b-8fef-8980c1d937c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elkton Middle School",
      "poi_type": "Education",
      "poi_address": "615 North St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1911-7095-b136-2a27a7f491aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1911-7095-b136-2a27a7f491aa",
        "storage_key": "property/6767906449166323/019fcdff-1911-7095-b136-2a27a7f491aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ems.ccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10042235733047163177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elkton-middle-school",
      "poi_latitude": "39.6201641",
      "poi_longitude": "-75.8302293",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-996-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK5VMVRWvx4kRKbkCczEwXYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_80d3e3ec-54c6-437e-a04b-8514c5412421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elkton High School",
      "poi_type": "Education",
      "poi_address": "110 James St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-192a-7324-af1a-2662222be3f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-192a-7324-af1a-2662222be3f6",
        "storage_key": "property/6767906449166323/019fcdff-192a-7324-af1a-2662222be3f6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://ehs.ccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3970820003482771307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elkton-high-school",
      "poi_latitude": "39.6223584",
      "poi_longitude": "-75.8348547",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 410-996-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56I5mxSvx4kRax-bPsEvGzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bcc1a159-2fb7-420c-a495-f7373d183fab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Gilpin Manor Elementary School",
      "poi_type": "Education",
      "poi_address": "203 Newark Ave, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1a49-741a-b7c8-735c1fd0d74a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1a49-741a-b7c8-735c1fd0d74a",
        "storage_key": "property/6767906449166323/019fcdff-1a49-741a-b7c8-735c1fd0d74a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccps.org/schools1/gilpin-manor-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=5096897436246540028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gilpin-manor-elementary-school",
      "poi_latitude": "39.6192995",
      "poi_longitude": "-75.83384579999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-996-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRIUcGuvx4kR_P4SuDbRu0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_80b21d2a-49ce-46a8-9483-fe3e1aeeb583",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Holly Hall Elementary School",
      "poi_type": "Education",
      "poi_address": "233 White Hall Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1edf-76cf-a54e-427daf914e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1edf-76cf-a54e-427daf914e12",
        "storage_key": "property/6767906449166323/019fcdff-1edf-76cf-a54e-427daf914e12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hhes.ccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12251759361158073318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holly-hall-elementary-school",
      "poi_latitude": "39.5926634",
      "poi_longitude": "-75.8215934",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 410-996-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF-oT5_Clx4kR5stk8zn-Bqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84988757-5c85-434e-8908-b39789de5730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Thomson Estates Elementary",
      "poi_type": "Education",
      "poi_address": "203 E Thomson Dr, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-1f51-710b-8d8b-c8a3a4e10682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-1f51-710b-8d8b-c8a3a4e10682",
        "storage_key": "property/6767906449166323/019fcdff-1f51-710b-8d8b-c8a3a4e10682.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ccps.org/tees",
      "poi_directions_map_url": "https://maps.google.com/?cid=7703222565885470444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomson-estates-elementary",
      "poi_latitude": "39.60529349999999",
      "poi_longitude": "-75.79909500000001",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-996-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLaj9P66ox4kR7GZgORxY52o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fa137b82-486b-4da3-852d-10a5d373f989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Kiddie Academy of Elkton",
      "poi_type": "Education",
      "poi_address": "100 Kiddie Ln, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-208c-723b-b97b-2c0f4a3e2934.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-208c-723b-b97b-2c0f4a3e2934",
        "storage_key": "property/6767906449166323/019fcdff-208c-723b-b97b-2c0f4a3e2934.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/elkton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16236591005428485469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-elkton",
      "poi_latitude": "39.6049737",
      "poi_longitude": "-75.7888622",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-398-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ_SIH6Oox4kRXQ3eiX71U-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_45bac35c-9847-4bbb-9a19-67ba549503d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "YMCA of Cecil County",
      "poi_type": "Education",
      "poi_address": "25 YMCA Blvd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-20e8-7673-b0da-243466ea8d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-20e8-7673-b0da-243466ea8d17",
        "storage_key": "property/6767906449166323/019fcdff-20e8-7673-b0da-243466ea8d17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ymcachesapeake.org/locations/cecil-county-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=11923455048475583586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-of-cecil-county",
      "poi_latitude": "39.6084304",
      "poi_longitude": "-75.8518521",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-398-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZGEHby4x4kRYqS5gzGfeKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33927e9c-9b4d-49a7-899e-f9b400c45513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil College",
      "poi_type": "Education",
      "poi_address": "1 Seahawk Dr, North East, MD 21901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2617-774f-88a3-795d8232fd57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2617-774f-88a3-795d8232fd57",
        "storage_key": "property/6767906449166323/019fcdff-2617-774f-88a3-795d8232fd57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cecil.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3951047800092522846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-college",
      "poi_latitude": "39.6410008",
      "poi_longitude": "-75.95652969999999",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFTLDnPGwx4kRXnkaZwrx1DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07bc9671-8620-463d-ad0f-3fc5fb182822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Tri-State Christian Academy",
      "poi_type": "Education",
      "poi_address": "146 Appleton Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-255c-747b-b18e-c584ef33491d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-255c-747b-b18e-c584ef33491d",
        "storage_key": "property/6767906449166323/019fcdff-255c-747b-b18e-c584ef33491d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tristatechristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1191579982450157632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tri-state-christian-academy",
      "poi_latitude": "39.6252937",
      "poi_longitude": "-75.8230895",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-398-6444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZUQFjTuvx4kRQGhoR65XiRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17c01f96-62ec-4b11-9240-db633f1abced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elkton Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "107 North St, Elkton, MD 21921, USA",
      "poi_short_description": "Live venue set to host touring bands and local acts, with a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-26e0-75c8-9ffc-c378da8f02c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-26e0-75c8-9ffc-c378da8f02c6",
        "storage_key": "property/6767906449166323/019fcdff-26e0-75c8-9ffc-c378da8f02c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elktonmusichall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17547032548438048397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elkton-music-hall",
      "poi_latitude": "39.6081315",
      "poi_longitude": "-75.83008989999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDSuvBfKvx4kRjf7ddyKVg_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44db7760-2b45-497e-9831-404434d24ff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Showcase On Main",
      "poi_type": "Entertainment",
      "poi_address": "116 E Main St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-27b7-7459-b260-04f3e08a66fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-27b7-7459-b260-04f3e08a66fb",
        "storage_key": "property/6767906449166323/019fcdff-27b7-7459-b260-04f3e08a66fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.showcaseonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=387465531995073044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "showcase-on-main",
      "poi_latitude": "39.6078161",
      "poi_longitude": "-75.8291777",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 443-252-2155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZfkia2vx4kRFCpGNdmNYAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f95f45a-b740-478c-beee-96bb7326091b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elk River Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "112 E Main St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2b44-7208-b010-3c92ceb977f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2b44-7208-b010-3c92ceb977f4",
        "storage_key": "property/6767906449166323/019fcdff-2b44-7208-b010-3c92ceb977f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elkriverbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7498908632368870091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-river-brewing-company",
      "poi_latitude": "39.6078048",
      "poi_longitude": "-75.8293688",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 443-207-8454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7e-nV2vx4kRy_J0k6t5EWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9051825b-51ea-4f8c-8961-b90f28d041b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Valhalla Brewing Co",
      "poi_type": "Entertainment",
      "poi_address": "41 Cherry Hill Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2d47-7732-b66a-8fbd791ac78b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2d47-7732-b66a-8fbd791ac78b",
        "storage_key": "property/6767906449166323/019fcdff-2d47-7732-b66a-8fbd791ac78b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valhallabrewco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8115953984845284740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valhalla-brewing-co",
      "poi_latitude": "39.6553513",
      "poi_longitude": "-75.8515451",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 443-207-8059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3dBHt_eux4kRhIUeKCapoXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_39f8a7c4-f682-434a-8a60-564c23ba0bf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil College- Elkton Station",
      "poi_type": "Entertainment",
      "poi_address": "107 Railroad Ave, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2d2e-755c-b300-736184884d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2d2e-755c-b300-736184884d22",
        "storage_key": "property/6767906449166323/019fcdff-2d2e-755c-b300-736184884d22.webp",
        "width": 635,
        "height": 1280
      },
      "poi_business_url": "http://www.cecil.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17341786015317304624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-college--elkton-station",
      "poi_latitude": "39.6107293",
      "poi_longitude": "-75.8321205",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-287-1078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAd9rLFWvx4kRMCXTDYBmqvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f87ce2ce-a725-4bca-8fd3-adbd572abf78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Milburn Stone Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1 Seahawk Dr, North East, MD 21901, USA",
      "poi_short_description": "Campus-based venue with stadium seating staging plays ranging from classics to modern musicals.",
      "poi_long_description": "Campus-based venue with stadium seating staging plays ranging from classics to modern musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2e15-704b-a54a-e040ebf06e32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2e15-704b-a54a-e040ebf06e32",
        "storage_key": "property/6767906449166323/019fcdff-2e15-704b-a54a-e040ebf06e32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.milburnstone.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16063228429400852177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milburn-stone-theatre",
      "poi_latitude": "39.6410382",
      "poi_longitude": "-75.9564891",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 410-287-1037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl52pivGwx4kR0cZkYCYN7N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab7b2333-bbdf-433f-a508-395259043da2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Fair Hill State Natural Resources Management Area",
      "poi_type": "Entertainment",
      "poi_address": "300 Tawes Dr, Elkton, MD 21921, USA",
      "poi_short_description": "Offering many trails for hiking, biking, and horseback riding, this area also features a covered bridge.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3311-707c-9af9-2a6d5cb00a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3311-707c-9af9-2a6d5cb00a59",
        "storage_key": "property/6767906449166323/019fcdff-3311-707c-9af9-2a6d5cb00a59.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/central/fairhill.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=18350241297046687675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-hill-state-natural-resources-management-area",
      "poi_latitude": "39.7067897",
      "poi_longitude": "-75.8559853",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 410-398-1246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRgmcyGsx4kRu88rZTwnqf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be226ffd-b633-4e8b-9222-f20ac04b4ba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elk Neck State Park",
      "poi_type": "Entertainment",
      "poi_address": "4395 Turkey Point Rd, North East, MD 21901, USA",
      "poi_short_description": "Bayside park has an 1833 lighthouse & recreation such as fishing & hiking, plus camping facilities.",
      "poi_long_description": "Bayside park has an 1833 lighthouse & recreation such as fishing & hiking, plus camping facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3349-7589-88eb-36bb4dd073b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3349-7589-88eb-36bb4dd073b7",
        "storage_key": "property/6767906449166323/019fcdff-3349-7589-88eb-36bb4dd073b7.webp",
        "width": 1280,
        "height": 936
      },
      "poi_business_url": "http://dnr2.maryland.gov/publiclands/Pages/central/elkneck.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10034528456404569884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-neck-state-park",
      "poi_latitude": "39.4838764",
      "poi_longitude": "-75.9831038",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 410-287-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfnD4cK9x4kRHA-LRHfOQYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c670e84c-7ef6-4ed6-be02-1d8fa909ba9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Hollywood Casino Perryville",
      "poi_type": "Entertainment",
      "poi_address": "1201 Chesapeake Overlook Pkwy, Perryville, MD 21903, USA",
      "poi_short_description": "Destination for 24-hour slots, live table games & entertainment such as comedy, trivia & karaoke.",
      "poi_long_description": "Destination for 24-hour slots, live table games & entertainment such as comedy, trivia & karaoke.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-33ce-73ec-8172-684d2612469c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-33ce-73ec-8172-684d2612469c",
        "storage_key": "property/6767906449166323/019fcdff-33ce-73ec-8172-684d2612469c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hollywoodcasinoperryville.com/?utm_source=google&utm_medium=organic&utm_campaign=localseo",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690664042843105075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hollywood-casino-perryville",
      "poi_latitude": "39.59573210000001",
      "poi_longitude": "-76.0743473",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 410-378-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuboM0WS4x4kRM2d8fbVLHrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f92946b7-8e65-4328-9dbc-c54e33d5888d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Milburn Orchards",
      "poi_type": "Entertainment",
      "poi_address": "1495 Appleton Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-349b-707c-979b-2f3151b90dd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-349b-707c-979b-2f3151b90dd9",
        "storage_key": "property/6767906449166323/019fcdff-349b-707c-979b-2f3151b90dd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.milburnorchards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4569834344232755842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milburn-orchards",
      "poi_latitude": "39.6703155",
      "poi_longitude": "-75.8149585",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-398-1349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVSkZ66ux4kRgqJfwh9Qaz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b94fba6-9c00-4f67-a43f-1327671f82b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "ChristianaCare Union Hospital",
      "poi_type": "Health",
      "poi_address": "106 Bow St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3a27-750e-b795-cc866cf9b3a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3a27-750e-b795-cc866cf9b3a6",
        "storage_key": "property/6767906449166323/019fcdff-3a27-750e-b795-cc866cf9b3a6.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.uhcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=156164251744286827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-union-hospital",
      "poi_latitude": "39.6089168",
      "poi_longitude": "-75.8323319",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 410-398-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8f77-70cc-8506-505d96347054",
        "storage_key": "property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-tSu2evx4kRazjVP4_OKgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40efd943-cc2b-456b-9f0b-e2131fd522f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "ChristianaCare-GoHealth Urgent Care",
      "poi_type": "Health",
      "poi_address": "310 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3a44-706f-bda4-47f3d2e42af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3a44-706f-bda4-47f3d2e42af7",
        "storage_key": "property/6767906449166323/019fcdff-3a44-706f-bda4-47f3d2e42af7.webp",
        "width": 1280,
        "height": 896
      },
      "poi_business_url": "https://www.gohealthuc.com/christianacare/locations/elkton?utm_source=gmb&utm_medium=organic&utm_content=cc-elkton",
      "poi_directions_map_url": "https://maps.google.com/?cid=2447188447052741393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-gohealth-urgent-care",
      "poi_latitude": "39.5968763",
      "poi_longitude": "-75.81837689999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 443-485-6213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6gzuqClx4kREbsERe0o9iE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_965582f8-5f85-49c6-801a-bf140dc8654f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health",
      "poi_address": "1000 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3a0f-73f9-9de3-81e748488e41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3a0f-73f9-9de3-81e748488e41",
        "storage_key": "property/6767906449166323/019fcdff-3a0f-73f9-9de3-81e748488e41.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1860-elkton-md/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17550878252251417786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "39.6032546",
      "poi_longitude": "-75.7929228",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-398-1123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8fe5-708a-b989-a16c728a1d5a",
        "storage_key": "property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMX53AqWox4kRugyTKcg-kfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b52ce470-c6e0-4051-996c-0421e10114f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "723 N Bridge St, Elkton, MD 21921, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-12b2-760c-8ca5-f50d8580f0e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-12b2-760c-8ca5-f50d8580f0e4",
        "storage_key": "property/6767906449166323/019fcdff-12b2-760c-8ca5-f50d8580f0e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/elkton-md-pharmacies/723-n-bridge-st-elkton-md-21921/storeid=11063?WT.mc_id=LS_GOOGLE_FS_11063",
      "poi_directions_map_url": "https://maps.google.com/?cid=5219221209079693848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.6184759",
      "poi_longitude": "-75.8389327",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-392-2961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWuSrW2vx4kRGEJhewlmbkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d9e159e-d942-4983-9ad0-fe34afa5ace9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health",
      "poi_address": "301 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3a99-772f-ae39-c420f4df5f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3a99-772f-ae39-c420f4df5f65",
        "storage_key": "property/6767906449166323/019fcdff-3a99-772f-ae39-c420f4df5f65.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-301+e+pulaski+hwy-elkton-md-21921/id=10977",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067126809570092444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.5987216",
      "poi_longitude": "-75.8187291",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-620-1325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8fe5-708a-b989-a16c728a1d5a",
        "storage_key": "property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9iPAFivx4kRnKW47i0yzw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b54da287-b40b-4191-aa33-95cfb46dc6cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Welcare Pharmacy LLC",
      "poi_type": "Health",
      "poi_address": "218 E Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3fa9-7304-95ca-388b241add21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3fa9-7304-95ca-388b241add21",
        "storage_key": "property/6767906449166323/019fcdff-3fa9-7304-95ca-388b241add21.webp",
        "width": 574,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17247525688618247776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "welcare-pharmacy-llc",
      "poi_latitude": "39.5981264",
      "poi_longitude": "-75.82226960000001",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 443-207-5105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8fe5-708a-b989-a16c728a1d5a",
        "storage_key": "property/6767906449166323/019d0266-8fe5-708a-b989-a16c728a1d5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9E2_7qlx4kRYOaDhDuFW-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_64ddf00e-4b6a-43dc-b896-d7381369d765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "153 Big Elk Mall, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4016-7573-892b-b598a7ed6123.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4016-7573-892b-b598a7ed6123",
        "storage_key": "property/6767906449166323/019fcdff-4016-7573-892b-b598a7ed6123.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/elkton-md?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14795163401450441668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.6001808",
      "poi_longitude": "-75.8231164",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-996-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd0SOGCvx4kRxEtQubn6Us0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b3b88b8-8e0a-4dc6-967d-0c515bbf2845",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "YMCA of Cecil County",
      "poi_type": "Health",
      "poi_address": "25 YMCA Blvd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-20e8-7673-b0da-243466ea8d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-20e8-7673-b0da-243466ea8d17",
        "storage_key": "property/6767906449166323/019fcdff-20e8-7673-b0da-243466ea8d17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ymcachesapeake.org/locations/cecil-county-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=11923455048475583586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-of-cecil-county",
      "poi_latitude": "39.6084304",
      "poi_longitude": "-75.8518521",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-398-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZGEHby4x4kRYqS5gzGfeKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1c111ea-66ce-401c-9895-cc463029dfcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Lotus Strength Yoga",
      "poi_type": "Health",
      "poi_address": "1414 W Pulaski Hwy appt c, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-407f-723c-8a34-62352c7a1b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-407f-723c-8a34-62352c7a1b06",
        "storage_key": "property/6767906449166323/019fcdff-407f-723c-8a34-62352c7a1b06.webp",
        "width": 1280,
        "height": 732
      },
      "poi_business_url": "https://lotusstrength.yoga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16356194989826908915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lotus-strength-yoga",
      "poi_latitude": "39.6096902",
      "poi_longitude": "-75.90510809999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 443-553-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ__Ms0dGxx4kR8yKoNa_g_OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43e37ca3-225c-4d22-b51a-ed1f189d177d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Meadow Park",
      "poi_type": "Nature",
      "poi_address": "Elkton, MD 21921, USA",
      "poi_short_description": "Recreational park with a creek, walking trails & fields for softball & football, plus playgrounds.",
      "poi_long_description": "Recreational park with a creek, walking trails & fields for softball & football, plus playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-41a2-7346-991d-49215aae2109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-41a2-7346-991d-49215aae2109",
        "storage_key": "property/6767906449166323/019fcdff-41a2-7346-991d-49215aae2109.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.elkton.org/parks-recreation/pages/park-locations-amenities",
      "poi_directions_map_url": "https://maps.google.com/?cid=7758681638619792647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-park",
      "poi_latitude": "39.6058308",
      "poi_longitude": "-75.8216553",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-620-7964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ51ibWlCvx4kRB0VH09dfrGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_944017dc-0c72-485b-b586-f1c941412dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Marina Park",
      "poi_type": "Nature",
      "poi_address": "131-149 W Pulaski Hwy, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4664-71bd-bbd7-93ef663f6a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4664-71bd-bbd7-93ef663f6a43",
        "storage_key": "property/6767906449166323/019fcdff-4664-71bd-bbd7-93ef663f6a43.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14747963578164911648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marina-park",
      "poi_latitude": "39.6032342",
      "poi_longitude": "-75.83265329999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cP-C0Ovx4kRIB7rfLxKq8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96e23fab-e797-4825-b618-01352272697d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Elk River Park Boat Launch",
      "poi_type": "Nature",
      "poi_address": "32 River Bend Pkwy, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4693-754f-94c4-4d22a3b6d565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4693-754f-94c4-4d22a3b6d565",
        "storage_key": "property/6767906449166323/019fcdff-4693-754f-94c4-4d22a3b6d565.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccgov.org/Home/Components/FacilityDirectory/FacilityDirectory/8/220",
      "poi_directions_map_url": "https://maps.google.com/?cid=9260417254249815047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-river-park-boat-launch",
      "poi_latitude": "39.5816522",
      "poi_longitude": "-75.8520774",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 410-996-5385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuS0IUgqlx4kRB1x1z22cg4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afd0a556-c194-4f79-a1f6-e80b3d446302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Hatchery Park",
      "poi_type": "Nature",
      "poi_address": "J56Q+89, 425 Delaware Ave, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4822-73ac-b4a0-a0d0b2a023bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4822-73ac-b4a0-a0d0b2a023bb",
        "storage_key": "property/6767906449166323/019fcdff-4822-73ac-b4a0-a0d0b2a023bb.webp",
        "width": 1280,
        "height": 923
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11292914341225794453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatchery-park",
      "poi_latitude": "39.6093534",
      "poi_longitude": "-75.8129122",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8BSn2Cvx4kRlYuty8J9uJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2db4ca7-23ec-4e36-8b86-f2cd7c297d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cow Pond Recreation Area",
      "poi_type": "Nature",
      "poi_address": "269 E Main St, Elkton, MD 21921, USA",
      "poi_short_description": "Peaceful, clean park with picnic tables, a pavilion, a pond and benches, plus fishing for trout, bass and catfish.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-48ee-72c8-b3cd-7ed4f4140a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-48ee-72c8-b3cd-7ed4f4140a11",
        "storage_key": "property/6767906449166323/019fcdff-48ee-72c8-b3cd-7ed4f4140a11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10502264075139090759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cow-pond-recreation-area",
      "poi_latitude": "39.6110306",
      "poi_longitude": "-75.81814969999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2bB6SCvx4kRRwkDcIiJv5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9268632e-e00b-4a61-b82b-a376b09ba28c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Eder Park Baseball Fields",
      "poi_type": "Nature",
      "poi_address": "110 Howard St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4d20-771e-a1b9-d1d1b9cc86a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4d20-771e-a1b9-d1d1b9cc86a1",
        "storage_key": "property/6767906449166323/019fcdff-4d20-771e-a1b9-d1d1b9cc86a1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2940549945374332240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eder-park-baseball-fields",
      "poi_latitude": "39.6080131",
      "poi_longitude": "-75.8278579",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9H2olyvx4kRUNVUepjuzig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5188b8af-2507-40de-a3ec-5c2c5f4d9b11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Brantwood Regional Park",
      "poi_type": "Nature",
      "poi_address": "Williams Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Family-oriented park featuring a playground, walking paths and disc golf.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4eb2-7765-bcd7-7f62fcb7dc4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4eb2-7765-bcd7-7f62fcb7dc4b",
        "storage_key": "property/6767906449166323/019fcdff-4eb2-7765-bcd7-7f62fcb7dc4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13459789996042582415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brantwood-regional-park",
      "poi_latitude": "39.5670686",
      "poi_longitude": "-75.80545049999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xjlWI2nx4kRj3l5ObDHyro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba124295-4b01-44fa-b36e-3ed4aa280eec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Fair Hill Nature Center",
      "poi_type": "Nature",
      "poi_address": "630 Tawes Dr, Elkton, MD 21921, USA",
      "poi_short_description": "Nature preserve featuring trails, horseback riding and a covered wooden bridge for viewing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-4fca-7408-bc1b-24e7261a899a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-4fca-7408-bc1b-24e7261a899a",
        "storage_key": "property/6767906449166323/019fcdff-4fca-7408-bc1b-24e7261a899a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://fairhillnature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9879330365315355904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-hill-nature-center",
      "poi_latitude": "39.7099871",
      "poi_longitude": "-75.8394835",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 410-398-4909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSfQDUysx4kRABVa059uGok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_530ae8ef-1cb1-4d53-83e3-1bcc54754b6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Fair Hill State Natural Resources Management Area",
      "poi_type": "Nature",
      "poi_address": "300 Tawes Dr, Elkton, MD 21921, USA",
      "poi_short_description": "Offering many trails for hiking, biking, and horseback riding, this area also features a covered bridge.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3311-707c-9af9-2a6d5cb00a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3311-707c-9af9-2a6d5cb00a59",
        "storage_key": "property/6767906449166323/019fcdff-3311-707c-9af9-2a6d5cb00a59.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/central/fairhill.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=18350241297046687675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-hill-state-natural-resources-management-area",
      "poi_latitude": "39.7067897",
      "poi_longitude": "-75.8559853",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 410-398-1246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRgmcyGsx4kRu88rZTwnqf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c8a1eea-e2a2-4a18-87f0-1dd36a8ee78f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Susquehanna State Park",
      "poi_type": "Nature",
      "poi_address": "4118 Wilkinson Rd, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_long_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5097-7359-bd40-7a6907e205e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5097-7359-bd40-7a6907e205e9",
        "storage_key": "property/6767906449166323/019fcdff-5097-7359-bd40-7a6907e205e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/central/susquehanna.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1816830562212225339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susquehanna-state-park",
      "poi_latitude": "39.60630949999999",
      "poi_longitude": "-76.16026459999999",
      "poi_miles_from_property": "96.8 mi",
      "poi_walking_minutes": "1 day 12 hours",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 410-557-7994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b5e-7290-bb24-4a7c6a1367ee",
        "storage_key": "property/6767906449166323/019d0266-8b5e-7290-bb24-4a7c6a1367ee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R92Tl7Gx4kRO6G7NcWtNhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02787b9a-c6da-4064-b6e0-5a5511075579",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Perryville Train Station (Broad St)",
      "poi_type": "Transit",
      "poi_address": "Perryville, MD 21903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14631222136954874030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perryville-train-station-broad-st",
      "poi_latitude": "39.558908",
      "poi_longitude": "-76.074013",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 39 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8fe5-708a-b989-9ec01e118e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8fe5-708a-b989-9ec01e118e94",
        "storage_key": "property/6767906449166323/019d0266-8fe5-708a-b989-9ec01e118e94.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ830f_q-4x4kRrugGlwOLDMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31c04d7c-66c0-40e9-969a-8f3d014bb5ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Churchman's Crossing",
      "poi_type": "Transit",
      "poi_address": "Delaware 19713, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-54cc-71c0-b938-a85ef3ea9484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-54cc-71c0-b938-a85ef3ea9484",
        "storage_key": "property/6767906449166323/019fcdff-54cc-71c0-b938-a85ef3ea9484.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/m/stations/rail/churchmans.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9155545375220360384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "churchmans-crossing",
      "poi_latitude": "39.6944296",
      "poi_longitude": "-75.6730312",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-92a8-73d6-9285-b8f520d460af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-92a8-73d6-9285-b8f520d460af",
        "storage_key": "property/6767906449166323/019d0266-92a8-73d6-9285-b8f520d460af.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRo9cPwAx4kRwOT6tgIID38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd0d14a2-da0a-49c3-832d-05be28e80e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil Transit",
      "poi_type": "Transit",
      "poi_address": "200 Chesapeake Blvd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5608-70b2-99b0-0958be7283f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5608-70b2-99b0-0958be7283f1",
        "storage_key": "property/6767906449166323/019fcdff-5608-70b2-99b0-0958be7283f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ccgov.org/government/community-services/cecil-transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=9269883750915565180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-transit",
      "poi_latitude": "39.5979554",
      "poi_longitude": "-75.7856481",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-996-5295 ext. 2",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-9378-7248-91c1-c7e3c27a3ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-9378-7248-91c1-c7e3c27a3ab5",
        "storage_key": "property/6767906449166323/019d0266-9378-7248-91c1-c7e3c27a3ab5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRC-rEKvx4kRfOZ8Uig-pYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b338a331-a7f9-4b23-8eb9-9edaf6fe1ee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "TA Travel Center",
      "poi_type": "Transit",
      "poi_address": "1400 Elkton Rd, Elkton, MD 21921, USA",
      "poi_short_description": "Stop off for gas, diesel, and food, and use the showers, lounge, and laundry facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5687-727d-97b6-094652c629b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5687-727d-97b6-094652c629b7",
        "storage_key": "property/6767906449166323/019fcdff-5687-727d-97b6-094652c629b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ta-petro.com/location/md/ta-elkton",
      "poi_directions_map_url": "https://maps.google.com/?cid=7587360149774762447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-travel-center",
      "poi_latitude": "39.6437155",
      "poi_longitude": "-75.7975165",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 410-398-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b74-717f-8b05-4c7464f4963a",
        "storage_key": "property/6767906449166323/019d0266-8b74-717f-8b05-4c7464f4963a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ3OTDy-px4kRz4FHTtu3S2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4f829ce-5b83-4fd3-8d13-18a8a446dc79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Claremont Airport 58M",
      "poi_type": "Transit",
      "poi_address": "166 Raintree Ln, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-575b-7407-a979-7586ddc0ba61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-575b-7407-a979-7586ddc0ba61",
        "storage_key": "property/6767906449166323/019fcdff-575b-7407-a979-7586ddc0ba61.webp",
        "width": 1280,
        "height": 712
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17888283686777939948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "claremont-airport-58m",
      "poi_latitude": "39.5745773",
      "poi_longitude": "-75.8688201",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 410-398-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-93e9-74f9-ac9a-487e329ef7b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-93e9-74f9-ac9a-487e329ef7b5",
        "storage_key": "property/6767906449166323/019d0266-93e9-74f9-ac9a-487e329ef7b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_5_nBClx4kR7GfQpzzzP_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35a593b9-fec2-41c2-a999-e90a5876421e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Wilmington",
      "poi_type": "Transit",
      "poi_address": "100 French St, Wilmington, DE 19801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5b97-7787-b43c-a045e6dd264c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5b97-7787-b43c-a045e6dd264c",
        "storage_key": "property/6767906449166323/019fcdff-5b97-7787-b43c-a045e6dd264c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WIL",
      "poi_directions_map_url": "https://maps.google.com/?cid=7825201090715334340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington",
      "poi_latitude": "39.7371953",
      "poi_longitude": "-75.5512614",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-92a8-73d6-9285-b8f520d460af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-92a8-73d6-9285-b8f520d460af",
        "storage_key": "property/6767906449166323/019d0266-92a8-73d6-9285-b8f520d460af.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbZWF-2f9xokRxDYWrO6ymGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b9114d4-830f-45a8-bb10-fbe5b3d60d31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Christiana Mall Park & Ride",
      "poi_type": "Transit",
      "poi_address": "Christiana, DE 19702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5c6c-708a-9ffc-0e79b20dc50f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5c6c-708a-9ffc-0e79b20dc50f",
        "storage_key": "property/6767906449166323/019fcdff-5c6c-708a-9ffc-0e79b20dc50f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12965177574651476672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christiana-mall-park--ride-inside",
      "poi_latitude": "39.67993200000001",
      "poi_longitude": "-75.655795",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGfoXAhgBx4kRwDr2yk-Q7bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_92a90ed2-aa79-4d0b-b32a-8b00f2a42c18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Hog Island Rd at UPS Air Hub",
      "poi_type": "Transit",
      "poi_address": "1 Hog Island Rd, Philadelphia, PA 19153, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5d2d-758b-ba11-44a70f629777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5d2d-758b-ba11-44a70f629777",
        "storage_key": "property/6767906449166323/019fcdff-5d2d-758b-ba11-44a70f629777.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7701091938213145188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hog-island-rd-at-ups-air-hub",
      "poi_latitude": "39.8584444",
      "poi_longitude": "-75.2575318",
      "poi_miles_from_property": "34.7 mi",
      "poi_walking_minutes": "12 hours 51 mins",
      "poi_biking_minutes": "3 hours 15 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8fe5-708a-b989-9ec01e118e94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8fe5-708a-b989-9ec01e118e94",
        "storage_key": "property/6767906449166323/019d0266-8fe5-708a-b989-9ec01e118e94.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4wHTVDDxokRZKrRz1DG32o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a3a9aa1c-2a5a-426a-8350-35b8126ce917",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "ChristianaCare Union Hospital",
      "poi_type": "Major Employers",
      "poi_address": "106 Bow St, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-3a27-750e-b795-cc866cf9b3a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-3a27-750e-b795-cc866cf9b3a6",
        "storage_key": "property/6767906449166323/019fcdff-3a27-750e-b795-cc866cf9b3a6.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.uhcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=156164251744286827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-union-hospital",
      "poi_latitude": "39.6089168",
      "poi_longitude": "-75.8323319",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 410-398-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8f77-70cc-8506-505d96347054",
        "storage_key": "property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-tSu2evx4kRazjVP4_OKgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5873a0ca-bb75-463b-a8c4-450309573909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil County Administration Office",
      "poi_type": "Major Employers",
      "poi_address": "200 Chesapeake Blvd # 2100, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-5d42-7198-8c92-0a37759f2c05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-5d42-7198-8c92-0a37759f2c05",
        "storage_key": "property/6767906449166323/019fcdff-5d42-7198-8c92-0a37759f2c05.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17226174715851486790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-county-administration-office",
      "poi_latitude": "39.5979612",
      "poi_longitude": "-75.785704",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-996-5203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-9378-7248-91c1-c7e3c27a3ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-9378-7248-91c1-c7e3c27a3ab5",
        "storage_key": "property/6767906449166323/019d0266-9378-7248-91c1-c7e3c27a3ab5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswUUpqGox4kRRrYkyaKqD-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44866b99-f162-4855-b2e6-becb894aba5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Terumo Cardiovascular Systems",
      "poi_type": "Major Employers",
      "poi_address": "125 Blue Ball Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.terumocv.com/index.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1269666880475929452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terumo-cardiovascular-systems",
      "poi_latitude": "39.610655",
      "poi_longitude": "-75.84427199999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 410-398-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA8gNkXqvx4kRbJvYAU3DnhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_229bb99b-bc05-4965-8b27-b7248ec8053d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "W. L. Gore & Associates, Inc. - Fair Hill",
      "poi_type": "Major Employers",
      "poi_address": "101 Lewisville Rd, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-62ae-77fe-ac95-91c2ae61eebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-62ae-77fe-ac95-91c2ae61eebd",
        "storage_key": "property/6767906449166323/019fcdff-62ae-77fe-ac95-91c2ae61eebd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18040755560624198364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-l-gore--associates-inc---fair-hill",
      "poi_latitude": "39.7070045",
      "poi_longitude": "-75.86938470000001",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 410-392-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdV7rpLitx4kR3JKoLpmjXfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_643b5984-72dc-41a1-a0bf-583c3f54cbf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Cecil College- Elkton Station",
      "poi_type": "Major Employers",
      "poi_address": "107 Railroad Ave, Elkton, MD 21921, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-2d2e-755c-b300-736184884d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-2d2e-755c-b300-736184884d22",
        "storage_key": "property/6767906449166323/019fcdff-2d2e-755c-b300-736184884d22.webp",
        "width": 635,
        "height": 1280
      },
      "poi_business_url": "http://www.cecil.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17341786015317304624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecil-college--elkton-station",
      "poi_latitude": "39.6107293",
      "poi_longitude": "-75.8321205",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-287-1078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAd9rLFWvx4kRMCXTDYBmqvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b2bafcd-bf7f-423d-b52b-c1137fa17ec9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Perry Point VA Medical Center",
      "poi_type": "Major Employers",
      "poi_address": "Perry Point VA Medical Center Building 23H, Perry Point, MD 21902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.va.gov/maryland-health-care/locations/perry-point-va-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6874320347650789441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perry-point-va-medical-center-building-23h",
      "poi_latitude": "39.5500106",
      "poi_longitude": "-76.06276700000001",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 10 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 410-605-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8f77-70cc-8506-505d96347054",
        "storage_key": "property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWHlNKm5x4kRQRD3Oe99Zl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_34fc61c8-21f7-4f15-967f-de2215f3785d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Aberdeen Proving Ground",
      "poi_type": "Major Employers",
      "poi_address": "6836 Civil Rd, Aberdeen Proving Ground, MD 21005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=6836+Civil+Rd,+Aberdeen+Proving+Ground,+MD+21005,+USA&ftid=0x89c7c0271e9d53cd:0xb09967fde40a8fa8&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "6836-civil-rd",
      "poi_latitude": "39.475353",
      "poi_longitude": "-76.115299",
      "poi_miles_from_property": "106 mi",
      "poi_walking_minutes": "1 day 15 hours",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EjU2ODM2IENpdmlsIFJkLCBBYmVyZGVlbiBQcm92aW5nIEdyb3VuZCwgTUQgMjEwMDUsIFVTQSIxEi8KFAoSCc1TnR4nwMeJEVQ2aE2DWjSqELQ1KhQKEglpTLcAIcDHiRE99omP0KjSlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_feeec9ad-0419-4007-8046-7dcafb7d719b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "ChristianaCare Christiana Hospital",
      "poi_type": "Major Employers",
      "poi_address": "4755 Ogletown Stanton Rd, Newark, DE 19718, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-634a-7669-8363-7d0059144ef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-634a-7669-8363-7d0059144ef3",
        "storage_key": "property/6767906449166323/019fcdff-634a-7669-8363-7d0059144ef3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://christianacare.org/facilities/christianahospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495470270249753645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-christiana-hospital",
      "poi_latitude": "39.6885738",
      "poi_longitude": "-75.67117739999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 302-733-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8f77-70cc-8506-505d96347054",
        "storage_key": "property/6767906449166323/019d0266-8f77-70cc-8506-505d96347054.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbcdfuEAx4kRLdxAZdCu6-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd3fc9f7-54b6-44ab-b44c-06c8651c4732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "University of Delaware STAR Campus",
      "poi_type": "Major Employers",
      "poi_address": "540 S College Ave, Newark, DE 19713, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-641d-73af-864d-64ca6ed70ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-641d-73af-864d-64ca6ed70ecc",
        "storage_key": "property/6767906449166323/019fcdff-641d-73af-864d-64ca6ed70ecc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://chs.udel.edu/star/",
      "poi_directions_map_url": "https://maps.google.com/?cid=680679057053624616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-delaware-star-campus",
      "poi_latitude": "39.6647429",
      "poi_longitude": "-75.75338200000002",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-831-1060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-8b76-707b-a921-e6de5c3da3ba",
        "storage_key": "property/6767906449166323/019d0266-8b76-707b-a921-e6de5c3da3ba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGRVDJISpx4kRKKm6-f5Bcgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d90a3e37-296e-49c3-8096-f5a7ba7c4ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "poi_name": "Amazon",
      "poi_type": "Major Employers",
      "poi_address": "1 Centerpoint Blvd, New Castle, DE 19720, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fcdff-6561-7697-81a9-4cff638183ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdff-6561-7697-81a9-4cff638183ed",
        "storage_key": "property/6767906449166323/019fcdff-6561-7697-81a9-4cff638183ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6147294140960272425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-phl1",
      "poi_latitude": "39.664243",
      "poi_longitude": "-75.5914478",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 206-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-86e4-71aa-a5b3-879bb29de68c",
        "storage_key": "property/6767906449166323/019d0266-86e4-71aa-a5b3-879bb29de68c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2ItC5EDx4kRKfDGkXOTT1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_8f006940-411b-43a1-b6f0-90f61dc82fbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d3526ade-2e91-4235-a418-fc54b26c5e06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9381972d-dee9-412b-b390-e2d9c5be3976",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9044e2a1-2191-484e-a1dd-ae974a56b6ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0db0bc08-b876-44ed-9e11-a49f712b8df1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_694a3fda-ed69-43e7-b770-7a36232fd90a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_57da15e9eb3f7f72b39bd712",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "rating": "5",
      "name": "Christiana Johnson",
      "text": "I just wanna thank Amanda the new property manager she goes above and beyond for your concerns she makes sure your living experience is heard and comfortable to your liking I had a issue and she got right to it handled it the best since I’ve been here and I’ve been here 2 years I haven’t experienced a property manager as best as she is. If your looking for comfortably peace and quiet and have all your concerns met come here",
      "date": "2025-11-19",
      "title": "false"
    },
    {
      "id": "ec_113ac18f3df1a6eecd3f2238",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "rating": "5",
      "name": "Tyrrell Wise",
      "text": "This was my first experience doing this. I was helped in any and every way possible to make this an amazing experience. Leasing agent SK was amazing and so helpful. I know I took her through a lot and she was just as professional as she could be. She made it easy for me.",
      "date": "2025-08-23",
      "title": "false"
    },
    {
      "id": "ec_66e37bc40ef0b4a4ac797b28",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "rating": "5",
      "name": "Nafeesah (Nafeesah)",
      "text": "New Management is the best & I mean the best they have made changes as far as the bad seeds that was here causing problems & for that reason I made up my mind to stay this is truly home Thank you soooo much Amanda 🫶🏾 your the best along with your team & maintenance",
      "date": "2025-11-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3a2b6bd7-9325-4ffb-a5e9-5de1256e14fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/019fa4da-61fe-7678-8654-04ba10b72f31.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa4da-61fe-7678-8654-04ba10b72f31",
        "storage_key": "property/6767906449166323/019fa4da-61fe-7678-8654-04ba10b72f31.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Stonegate at Iron Ridge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=631b5a719d960c4453814da5&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_274fc7efea415f0699f3d85c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429372",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ddcbee8b390dafda4a374da7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429373",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_d421dcf18f957602590800a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429374",
      "name": "Pet Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f64b4172c8cf2102a11752c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429375",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_24ed22d07eb5bd282c7b155d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429378",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fe4593db80c8c076c1ce1672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "429380",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9ecd882227ade83f66a53bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "543073",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2698ac76a9c6d2bb6e90ba3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "564943",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2cd7116524884bee9b4a0a6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "679905",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bedff57866a44cd958115472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "835161",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_970246caee8ea7516102a6e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "835163",
      "name": "Garage-Large Parking",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8c11722c02bdf9c69e6d5fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "835167",
      "name": "Late Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e7b279ddd901ecfe09180b78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "835170",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_220639f4aa46bbfd2df16f06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "835177",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5970d24bd7b0f62e870ad1b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "838621",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7be8d94d86bde27f033eceb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "838623",
      "name": "Trash Service",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f12fb86d331533c894d6f5ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "838625",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 50,
      "amount_max": 70,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_86e175b56473c8e04a255fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "engrain",
      "external_id": "945453",
      "name": "Month to Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a130e-00f5-7328-b97c-145de23092d7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-iron-ridge-and-stonegate-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323"
    },
    {
      "lead_collector_id": "019c3043-610e-7145-b238-fbd87f4dd2e1",
      "lead_source": "FACEBOOK_ADS",
      "name": "iron-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323"
    },
    {
      "lead_collector_id": "019c3043-6181-73ba-882e-845772bd64d9",
      "lead_source": "LANDING_PAGE",
      "name": "iron-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-elkton-md-450",
      "search_query": "pet friendly apartments Elkton MD",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Elkton, MD",
      "h2_subtitle": "Discover pet-friendly apartments at Iron Ridge and Stonegate in Elkton, MD where both you and your furry friends will feel at home.",
      "page_copy": "Welcome to Iron Ridge and Stonegate Apartments, the ultimate pet-friendly destination in Elkton, MD. Our community is designed with your pets in mind, featuring ample outdoor spaces like a dog park where your furry friends can roam freely. You'll find spacious floor plans that offer comfort and convenience for both you and your pets.\n\nNestled in the charming locality of Elkton, our community is not only pet-friendly but also equipped with modern amenities. Enjoy a stress-free living experience with facilities such as a tennis court and fitness center, while your pets explore their new surroundings. Move in today and enjoy the seamless blend of comfort and convenience we offer in Elkton, MD.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Elkton, MD",
      "seo_description": "Find pet-friendly apartments in Elkton, MD at Iron Ridge and Stonegate Apartments, offering comfort and top amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-with-pool-cecil-county-447",
      "search_query": "apartments with a pool Cecil County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Cecil County",
      "h2_subtitle": "Dive into relaxation at Iron Ridge and Stonegate Apartments in Cecil County with our exclusive swimming pool amenities.",
      "page_copy": "Experience the finest in apartment living at Iron Ridge and Stonegate Apartments in Cecil County. Our community features a beautiful swimming pool, ideal for unwinding after a long day or enjoying weekends with family and friends. These apartments are designed to offer a balance of fun and relaxation all year round.\n\nLocated in the heart of Elkton, our apartments provide residents access to top-notch amenities beyond just a refreshing pool. From fitness centers and tennis courts to thoughtfully designed living spaces, Iron Ridge and Stonegate Apartments redefine modern living in Cecil County. Come join a community where excitement and comfort are always at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Cecil County",
      "seo_description": "Enjoy apartments with a pool in Cecil County at Iron Ridge and Stonegate Apartments, offering top amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-elkton-21921-997",
      "search_query": "air conditioned apartments Elkton 21921",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Elkton, 21921",
      "h2_subtitle": "Stay cool and comfortable in our air-conditioned apartments at Iron Ridge and Stonegate, located in Elkton, 21921.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer perfectly air-conditioned accommodations in the heart of Elkton, 21921. Our modern living spaces ensure that you and your family experience comfort during every season. Each apartment is designed to provide an ideal living environment, allowing you to relax and unwind.\n\nBeyond air-conditioned living, our community in Elkton, MD, is equipped with exceptional amenities such as a fitness center and a swimming pool. Whether you are lounging at home or exploring our exclusive facilities, you'll enjoy every aspect of life at Iron Ridge and Stonegate Apartments. Make the move today and join a welcoming community in Elkton, 21921.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Elkton, 21921",
      "seo_description": "Find air-conditioned apartments in Elkton, 21921 at Iron Ridge and Stonegate Apartments, where comfort and amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "dog-park-apartments-elkton-md-538",
      "search_query": "dog park apartments Elkton MD",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Elkton, MD",
      "h2_subtitle": "Welcome to Iron Ridge and Stonegate Apartments in Elkton, MD, featuring an exclusive dog park for your furry friends.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer the ideal home for pet lovers in Elkton, MD. Our community features a dedicated dog park, where your four-legged companions can roam and play freely. It's the perfect setting for dog owners who value convenience and community living, ensuring both you and your pet have a delightful experience.\n\nBesides a fantastic dog park, residents at Iron Ridge and Stonegate enjoy a variety of amenities, including a swimming pool, fitness center, and thoughtfully designed living spaces. Situated in Elkton, MD, our pet-friendly apartments offer the perfect balance of comfort and recreation, making it a wonderful place for families with pets. Embrace a lifestyle where your furry friend is as excited to come home as you are.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Elkton, MD",
      "seo_description": "Live in dog park apartments in Elkton, MD at Iron Ridge and Stonegate, where pets enjoy freedom and amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-elkton-md-551",
      "search_query": "one bedroom apartments in Elkton MD",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Elkton, MD",
      "h2_subtitle": "Discover comfortable one-bedroom apartments in Elkton, MD at Iron Ridge and Stonegate, perfect for any lifestyle.",
      "page_copy": "Explore one-bedroom apartments at Iron Ridge and Stonegate in Elkton, MD, where modern living meets convenience. Our thoughtfully designed apartments offer spacious layouts that fit any lifestyle, whether you're a professional seeking a serene environment or someone looking for a cozy home.\n\nLocated in the heart of Elkton, MD, our community boasts a range of top-tier amenities, including a fitness center, tennis court, and swimming pool. These features not only enhance your living experience but also provide ample opportunities for relaxation and recreation. Come home to Iron Ridge and Stonegate, where you'll find the perfect one-bedroom apartment in Elkton, MD.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Elkton, MD",
      "seo_description": "Find one-bedroom apartments in Elkton, MD at Iron Ridge and Stonegate. Enjoy spacious layouts and premium amenities in a central location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-cecil-county-972",
      "search_query": "two bedroom apartments Cecil County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cecil County",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Cecil County at Iron Ridge and Stonegate Apartments.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer expansive two-bedroom layouts in the heart of Cecil County, ideal for families, roommates, or anyone seeking extra space. Our modern apartments are designed with your comfort in mind, providing an inviting environment that feels like home.\n\nSituated in Elkton, MD, within Cecil County, our community is more than just apartments. Residents enjoy exclusive access to top-notch amenities, such as a tennis court, a refreshing swimming pool, and a fitness center. Whether you're entertaining guests or enjoying a quiet evening at home, Iron Ridge and Stonegate Apartments provide the perfect setting for a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cecil County",
      "seo_description": "Find spacious two-bedroom apartments in Cecil County at Iron Ridge and Stonegate, where modern amenities meet a welcoming community in Elkton, MD.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-21921-284",
      "search_query": "three bedroom apartments near 21921",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 21921",
      "h2_subtitle": "Explore expansive three-bedroom apartments near 21921 at Iron Ridge and Stonegate Apartments, offering comfort and convenience.",
      "page_copy": "Located just near the 21921 area, Iron Ridge and Stonegate Apartments present spacious three-bedroom layouts perfect for families or those needing extra room. Our apartments boast contemporary designs and ample living space, ensuring everyone has the room they need to live comfortably.\n\nBeyond the well-appointed living spaces, residents enjoy access to high-quality amenities such as a private third-bedroom loft, a tennis court, and a playground for family fun. Nestled in the charming community of Elkton, MD, Iron Ridge and Stonegate Apartments combine the best of modern living and local convenience, making them an excellent choice for those seeking a three-bedroom residence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 21921",
      "seo_description": "Find three-bedroom apartments near 21921 at Iron Ridge and Stonegate in Elkton, MD, offering spacious layouts and premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-near-cecil-manor-elementary-73",
      "search_query": "apartments near Cecil Manor Elementary School Elkton MD",
      "category": "School",
      "h1_title": "Apartments Near Cecil Manor Elementary School",
      "h2_subtitle": "Explore comfortable living at Iron Ridge and Stonegate Apartments, conveniently located near Cecil Manor Elementary School in Elkton, MD.",
      "page_copy": "Choosing a home close to educational institutions is a priority for many families. Iron Ridge and Stonegate Apartments in Elkton, MD, offers the perfect solution with its proximity to Cecil Manor Elementary School. Our apartment community provides a supportive environment where convenience and quality meet.\n\nOur residents not only enjoy the perks of being near an excellent school but also have access to fantastic amenities like a fitness center and dog park. Designed with your family in mind, Iron Ridge and Stonegate caters to a balanced lifestyle that integrates educational opportunities with leisure and relaxation. Discover the ideal blend of location and lifestyle, right next to Cecil Manor Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cecil Manor Elementary School",
      "seo_description": "Find exceptional apartments near Cecil Manor Elementary in Elkton, MD at Iron Ridge and Stonegate. Enjoy family-friendly living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-close-to-elkton-middle-school-248",
      "search_query": "apartments close to Elkton Middle School 21921",
      "category": "School",
      "h1_title": "Apartments Close to Elkton Middle School",
      "h2_subtitle": "Discover the convenience of living near Elkton Middle School at Iron Ridge and Stonegate Apartments, providing quality family living in the 21921 area.",
      "page_copy": "Situated near Elkton Middle School, Iron Ridge and Stonegate Apartments offer an ideal living experience in the 21921 area, perfect for families seeking close proximity to school facilities. Our community ensures a smooth daily routine, with quick commutes making life easier and more enjoyable.\n\nBeyond the advantageous location, our residents benefit from access to outstanding amenities such as a modern fitness center, a tennis court, and a serene swimming pool. Iron Ridge and Stonegate Apartments provide a wholesome living experience where educational accessibility meets quality residential comforts, ensuring peace of mind for families focusing on their children's education and growth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Elkton Middle School",
      "seo_description": "Discover family-friendly apartments near Elkton Middle School at Iron Ridge and Stonegate in the 21921 area. Enjoy modern living with community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "rental-homes-near-elkton-high-school-17",
      "search_query": "rental homes near Elkton High School Elkton",
      "category": "School",
      "h1_title": "Rental Homes Near Elkton High School",
      "h2_subtitle": "Find the perfect rental homes near Elkton High School at Iron Ridge and Stonegate Apartments, combining convenience and excellent amenities.",
      "page_copy": "Iron Ridge and Stonegate Apartments in Elkton present an excellent choice for those seeking rental homes near Elkton High School. This prime location provides families and students with a stress-free commute and a supportive neighborhood environment, adding convenience to daily life.\n\nIn addition to its strategic location, the community boasts a variety of luxury amenities like a playground, a fully-equipped fitness center, and a dog park. Our spacious one, two, and three-bedroom layouts offer versatility and comfort, ensuring that every resident finds a home that perfectly suits their needs. Experience the perfect blend of convenience, amenity, and neighborhood spirit at Iron Ridge and Stonegate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Elkton High School",
      "seo_description": "Explore comfortable rental homes near Elkton High School at Iron Ridge and Stonegate in Elkton, MD, offering top amenities and spacious living options.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartment-homes-near-gilpin-manor-elementary-66",
      "search_query": "apartment homes near Gilpin Manor Elementary School Cecil County",
      "category": "School",
      "h1_title": "Apartment Homes Near Gilpin Manor Elementary",
      "h2_subtitle": "Discover apartment homes near Gilpin Manor Elementary School in Cecil County at Iron Ridge and Stonegate, offering superb living with top features.",
      "page_copy": "Finding the ideal home close to educational facilities is effortless with Iron Ridge and Stonegate Apartments, located near Gilpin Manor Elementary School in Cecil County. Our community is perfect for families prioritizing their child's education without sacrificing convenience or comfort.\n\nOur spacious and modern apartment homes are complemented by impressive amenities such as a large playground, a fitness center for wellness enthusiasts, and a serene swimming pool. At Iron Ridge and Stonegate, residents enjoy a harmonious blend of proximity to important educational resources and access to luxury community features, making family life both comfortable and fulfilling.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Gilpin Manor Elementary",
      "seo_description": "Find exceptional apartment homes near Gilpin Manor Elementary in Cecil County at Iron Ridge and Stonegate, where comfort meets convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "living-near-holly-hall-elementary-132",
      "search_query": "living near Holly Hall Elementary School Elkton MD",
      "category": "School",
      "h1_title": "Living Near Holly Hall Elementary School",
      "h2_subtitle": "Explore the benefits of living near Holly Hall Elementary School in Elkton, MD at Iron Ridge and Stonegate Apartments.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer an ideal setting for those looking to live near Holly Hall Elementary School in Elkton, MD. Our prime location ensures families enjoy both the convenience of a short commute and the peace of a friendly community.\n\nThe apartments boast a range of family-friendly amenities, including a safe playground, a modern fitness center, and a relaxing pool. Whether you choose a one, two, or three-bedroom floor plan, you'll find the comfort and convenience that make everyday living a pleasure. At Iron Ridge and Stonegate, enjoy easy access to quality education and community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Holly Hall Elementary School",
      "seo_description": "Enjoy the convenience of living near Holly Hall Elementary in Elkton, MD at Iron Ridge and Stonegate, offering modern amenities and spacious homes.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "housing-near-cecil-college-elkton-123",
      "search_query": "housing near Cecil College Elkton Maryland",
      "category": "School",
      "h1_title": "Housing Near Cecil College Elkton, MD",
      "h2_subtitle": "Explore housing options near Cecil College in Elkton, Maryland at Iron Ridge and Stonegate Apartments, combining comfort and strategic location.",
      "page_copy": "Iron Ridge and Stonegate Apartments provide exceptional housing near Cecil College in Elkton, Maryland, making it an ideal choice for students and faculty looking for convenience. Located just a short drive from campus, our community offers not only a strategic location but also a variety of amenities that enhance the living experience.\n\nChoose from spacious one, two, or three-bedroom layouts equipped with the comforts of modern living. Residents enjoy access to a well-maintained fitness center, a peaceful swimming pool, and beautifully landscaped grounds. Experience the perfect balance of academic focus and relaxation within a supportive living environment at Iron Ridge and Stonegate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Cecil College Elkton, MD",
      "seo_description": "Find convenient housing near Cecil College in Elkton, MD at Iron Ridge and Stonegate, offering modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-adjacent-tri-state-christian-academy-56",
      "search_query": "apartments adjacent to Tri-State Christian Academy Elkton MD",
      "category": "School",
      "h1_title": "Apartments by Tri-State Christian Academy",
      "h2_subtitle": "Discover apartments adjacent to Tri-State Christian Academy in Elkton, MD at Iron Ridge and Stonegate, where convenience meets quality living.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer premier living options adjacent to Tri-State Christian Academy in Elkton, MD. Ideal for families and staff seeking close proximity to this renowned educational institution, our community provides easy commutes and a nurturing living environment.\n\nResidents can choose from one, two, or three-bedroom units, each offering access to superb amenities including a tennis court, fitness center, and a refreshing swimming pool. Embrace a dynamic lifestyle surrounded by community comforts, all within a stone's throw from Tri-State Christian Academy. Experience supportive, quality living at Iron Ridge and Stonegate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Tri-State Christian Academy",
      "seo_description": "Find convenient apartments adjacent to Tri-State Christian Academy in Elkton, MD at Iron Ridge and Stonegate, featuring modern comforts and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-near-christianacare-union-hospital-508",
      "search_query": "apartments near ChristianaCare Union Hospital Elkton",
      "category": "Hospital",
      "h1_title": "Apartments Near ChristianaCare Union Hospital",
      "h2_subtitle": "Explore comfortable living options at Iron Ridge and Stonegate Apartments, conveniently near ChristianaCare Union Hospital in Elkton.",
      "page_copy": "Discover Iron Ridge and Stonegate Apartments, perfectly situated near ChristianaCare Union Hospital in Elkton, providing an ideal housing option for medical professionals and staff who need quick access to work. Our prime location ensures a straightforward commute while offering a peaceful living environment.\n\nChoose from our assortment of one, two, and three-bedroom apartments designed to meet your space needs. Take advantage of our community amenities like a state-of-the-art fitness center, a sparkling pool, and a serene neighborhood atmosphere. At Iron Ridge and Stonegate, enjoy convenience and comfort hand in hand, just minutes from ChristianaCare Union Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near ChristianaCare Union Hospital",
      "seo_description": "Find convenient apartments near ChristianaCare Union Hospital in Elkton, MD at Iron Ridge and Stonegate, offering easy commutes and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-near-meadow-park-elkton-157",
      "search_query": "apartments near Meadow Park in Elkton MD",
      "category": "Park",
      "h1_title": "Apartments Near Meadow Park Elkton, MD",
      "h2_subtitle": "Discover the perfect home near Meadow Park in Elkton, MD at Iron Ridge and Stonegate Apartments, where nature and city life blend effortlessly.",
      "page_copy": "Experience the best of both worlds at Iron Ridge and Stonegate Apartments, conveniently located near the serene Meadow Park in Elkton, MD. Our community offers a peaceful retreat close to one of the area's beloved green spaces, ideal for those who love outdoor activities without straying far from home.\n\nChoose from a variety of spacious floor plans including one, two, and three-bedroom options fit for any lifestyle. Residents can enjoy premium amenities such as a tennis court, dog park, and pristine swimming pool. Embrace the tranquility and accessibility of living near Meadow Park while enjoying top-notch comforts at Iron Ridge and Stonegate Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Meadow Park Elkton, MD",
      "seo_description": "Find tranquil apartments near Meadow Park in Elkton, MD at Iron Ridge and Stonegate, offering beautiful amenities and a nature-friendly location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "living-close-to-marina-park-elkton-265",
      "search_query": "living close to Marina Park Elkton Maryland",
      "category": "Park",
      "h1_title": "Living Close to Marina Park in Elkton, MD",
      "h2_subtitle": "Explore a vibrant community at Iron Ridge and Stonegate Apartments, offering living options close to Marina Park in Elkton, MD.",
      "page_copy": "Iron Ridge and Stonegate Apartments provide an exceptional living experience near Marina Park in Elkton, Maryland. Relish the opportunity to reside in close proximity to this picturesque waterfront destination, ideal for leisure and recreation by the water.\n\nOur community features thoughtfully designed one, two, and three-bedroom apartments, ensuring comfort and style for all residents. Take advantage of our exclusive amenities such as a playground, fitness center, and a dog park. Enjoy the harmonious blend of scenic beauty and modern living at Iron Ridge and Stonegate, just a short stroll from Marina Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Marina Park Elkton, MD",
      "seo_description": "Enjoy living close to Marina Park in Elkton, MD at Iron Ridge and Stonegate Apartments, blending modern amenities with scenic tranquility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "elkton-living-near-brantwood-regional-park-91",
      "search_query": "Elkton living close to Brantwood Regional Park",
      "category": "Park",
      "h1_title": "Elkton Living Close to Brantwood Park",
      "h2_subtitle": "Discover the charm of Elkton living near Brantwood Regional Park at Iron Ridge and Stonegate Apartments, offering convenience and comfort.",
      "page_copy": "Iron Ridge and Stonegate Apartments offer a desirable Elkton living experience, strategically located near Brantwood Regional Park. Perfect for those who enjoy nature and outdoor activities, our community provides convenient access to this beautiful park, ideal for family outings, fitness, and relaxation.\n\nChoose from our inviting one, two, and three-bedroom apartment homes that promise comfort and style. Enjoy community amenities like a dog park, tennis court, and fitness center, all designed to enhance your lifestyle. Experience the best of both worlds—nature and modern conveniences—by living close to Brantwood Regional Park at Iron Ridge and Stonegate Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elkton Living Close to Brantwood Park",
      "seo_description": "Experience Elkton living near Brantwood Regional Park at Iron Ridge and Stonegate, offering modern comfort and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "apartments-near-fair-hill-nature-center-cecil-25",
      "search_query": "apartments near Fair Hill Nature Center Cecil",
      "category": "Park",
      "h1_title": "Apartments Near Fair Hill Nature Center",
      "h2_subtitle": "Explore the wonders of Cecil County living at Iron Ridge and Stonegate Apartments, nestled near Fair Hill Nature Center.",
      "page_copy": "Discover Iron Ridge and Stonegate Apartments, where comfortable living meets natural beauty just minutes from Fair Hill Nature Center in Cecil County. For those who appreciate the great outdoors, our location offers easy access to the extensive trails and scenic vistas of Fair Hill, perfect for hiking, horseback riding, or simply enjoying nature.\n\nOur spacious one, two, and three-bedroom apartments provide a welcoming retreat with top-tier amenities like a fitness center and swimming pool. Experience a harmonious blend of serene natural settings and modern conveniences in your new home near Fair Hill Nature Center at Iron Ridge and Stonegate Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fair Hill Nature Center Cecil",
      "seo_description": "Explore apartments near Fair Hill Nature Center in Cecil County at Iron Ridge and Stonegate, offering modern amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166323",
      "source": "custom",
      "page_item_url": "susquehanna-state-park-proximity-rentals-44",
      "search_query": "Susquehanna State Park proximity rentals Elkton",
      "category": "Park",
      "h1_title": "Susquehanna Park Proximity Rentals Elkton",
      "h2_subtitle": "Experience Elkton living at Iron Ridge and Stonegate Apartments, conveniently located near Susquehanna State Park.",
      "page_copy": "Iron Ridge and Stonegate Apartments in Elkton, MD, offer an exceptional living experience with close proximity to Susquehanna State Park. Enjoy the tranquil surroundings and engage in activities such as hiking, biking, and picnicking, all easily accessible from our community.\n\nOur pet-friendly apartments feature spacious one, two, and three-bedroom layouts, designed for comfort and convenience. Take advantage of our top-notch amenities including a swimming pool, tennis court, and a fully-equipped fitness center. Discover the balance of nature and modern living with our rentals near Susquehanna State Park at Iron Ridge and Stonegate Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
      "featured_image_media": {
        "alt_text": "The Apartments at Iron Ridge monument sign with landscaping.",
        "public_id": "01a015da-3842-755f-9365-f07f7aa0c7de",
        "storage_key": "property/6767906449166323/01a015da-3842-755f-9365-f07f7aa0c7de.webp",
        "width": 2000,
        "height": 1333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Susquehanna Park Proximity Rentals Elkton",
      "seo_description": "Discover rentals near Susquehanna State Park in Elkton at Iron Ridge and Stonegate Apartments, offering access to nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5060"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976252961"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973394"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K4ZVVSKK"
    },
    {
      "ID": "custom_realpage_id_2",
      "type": "STRING",
      "value": "4973432"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://ironridgestonegateapartments.fatwin.com/api/websites/resources/1?x=NVlXdGU2NkZjeDBIclpObXZtMWNUYzRMeEhWMzQwUmovTDdqVGVmSExZdWw5TzJWMUI5b1pmM3huNW0wOTlzRm8zYXlPRmh1WWprSkJjdWJqNFRZOFE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54596677700"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwnlez5vd2"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_resident_portal_url_2",
      "type": "STRING",
      "value": "https://livestonegateatironridge.loftliving.com/login"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954a2d8c-43e6-11ef-8613-5382938af449"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a2d8c-43e6-11ef-8613-5382938af449/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a2d8c-43e6-11ef-8613-5382938af449/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik5HeVRlQW4ycjBTNy95NDNxVHkwZlE9PSIsInZhbHVlIjoidXpkeS9FRWFWWEoxcXFMckovc04vdz09IiwibWFjIjoiZDk1YjlhY2JkYzcwMmQ3ZjlkN2RhMzU1YTFkZjFhOTIzYWYzMDhmZDZiYTkwNjkxMzcxNTkxMTRlZDM4YjhhNiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5060",
  "custom_repli_id": "9976252961",
  "custom_realpage_id": "4973394",
  "custom_google_gtm_id": "GTM-K4ZVVSKK",
  "custom_realpage_id_2": "4973432",
  "custom_perq_script_url": "https://ironridgestonegateapartments.fatwin.com/api/websites/resources/1?x=NVlXdGU2NkZjeDBIclpObXZtMWNUYzRMeEhWMzQwUmovTDdqVGVmSExZdWw5TzJWMUI5b1pmM3huNW0wOTlzRm8zYXlPRmh1WWprSkJjdWJqNFRZOFE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "54596677700",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rkwnlez5vd2",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_resident_portal_url_2": "https://livestonegateatironridge.loftliving.com/login",
  "custom_eliseai_building_token": "954a2d8c-43e6-11ef-8613-5382938af449",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a2d8c-43e6-11ef-8613-5382938af449/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a2d8c-43e6-11ef-8613-5382938af449/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik5HeVRlQW4ycjBTNy95NDNxVHkwZlE9PSIsInZhbHVlIjoidXpkeS9FRWFWWEoxcXFMckovc04vdz09IiwibWFjIjoiZDk1YjlhY2JkYzcwMmQ3ZjlkN2RhMzU1YTFkZjFhOTIzYWYzMDhmZDZiYTkwNjkxMzcxNTkxMTRlZDM4YjhhNiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "851d518b-906a-4d4d-a8dd-3c8526d00b10",
  "custom_audioeye_site_hash": "e92e5b687a2dc519ed914277c64bc08b"
};

export const generatedAt = '2026-10-22T20:07:04.115Z';
